
// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box, Grid, Card, CardContent, Typography, Chip, CircularProgress,
//   Alert, LinearProgress, Table, TableHead, TableBody, TableRow,
//   TableCell, Paper, Avatar, Accordion, AccordionSummary,
//   AccordionDetails, Divider, Button, TextField,
//   Collapse, IconButton, Tooltip, Tab, Tabs,
// } from "@mui/material";
// import {
//   People, CheckCircle, Cancel, Groups, ExpandMore,
//   Work, Business, FiberManualRecord,
//   KeyboardArrowDown, KeyboardArrowUp,
//   Timeline, Refresh, TrendingUp, TrendingDown,
//   EmojiEvents, Star, Speed, BarChart as BarChartIcon,
//   Assignment, AssignmentTurnedIn, HourglassEmpty,
//   WorkOff, Verified,
// } from "@mui/icons-material";
// import {
//   Chart as ChartJS,
//   CategoryScale, LinearScale, BarElement, LineElement,
//   PointElement, ArcElement, RadialLinearScale,
//   Title, Tooltip as ChartTooltip, Legend, Filler,
// } from "chart.js";
// import { Bar, Line, Doughnut, Radar, Pie } from "react-chartjs-2";
// import ChartDataLabels from "chartjs-plugin-datalabels";

// ChartJS.register(
//   CategoryScale, LinearScale, BarElement, LineElement,
//   PointElement, ArcElement, RadialLinearScale,
//   Title, ChartTooltip, Legend, Filler, ChartDataLabels
// );

// // ─── CONFIG ──────────────────────────────────────────────────────────────────
// const BASE = process.env.REACT_APP_API_BASE_URL;
// const getHeaders = () => ({
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
// });

// const PALETTE = [
//   "#6366f1", "#0ea5e9", "#10b981", "#f59e0b",
//   "#ef4444", "#8b5cf6", "#ec4899", "#14b8a6",
// ];

// const STATUS_ORDER = [
//   "NewCandidate",
//   "Recruiter_Rejected","Recruiter_Accepted","Recruiter_Hold",
//   "HiringManager_Rejected","HiringManager_Accepted","HiringManager_Hold",
//   "ScreeningTest_Sent","ScreeningTest_Resent",
//   "Candidate_Declined","Candidate_OnHold","Candidate_Quit",
//   "ScreeningTest_Passed","ReScreeningTest_Passed",
//   "OnHold_ReScreening","OnHold_Screening",
//   "TestPassed_Rejected","ReTestPassed_Rejected",
//   "ScreeningTest_Failed","ReScreeningTest_Failed",
//   "OnHold_TestPassed",
//   "Interview_Scheduled","Round1_Rejected","Round2_Suggested",
//   "Round2_Scheduled","Interviewer_Selected","Interviewer_Rejected",
//   "Selected","Rejected",
// ];

// const STATUS_META = {
//   NewCandidate:           { bg:"#f1f5f9", color:"#475569",  label:"New Candidate" },
//   Recruiter_Rejected:     { bg:"#fef2f2", color:"#dc2626",  label:"Rctr Rejected" },
//   Recruiter_Accepted:     { bg:"#eff6ff", color:"#2563eb",  label:"Rctr Accepted" },
//   Recruiter_Hold:         { bg:"#fff7ed", color:"#c2410c",  label:"Rctr Hold" },
//   HiringManager_Rejected: { bg:"#fef2f2", color:"#991b1b",  label:"HM Rejected" },
//   HiringManager_Accepted: { bg:"#f0fdf4", color:"#166534",  label:"HM Accepted" },
//   HiringManager_Hold:     { bg:"#fff7ed", color:"#b45309",  label:"HM Hold" },
//   ScreeningTest_Sent:     { bg:"#fefce8", color:"#a16207",  label:"Test Sent" },
//   ScreeningTest_Resent:   { bg:"#fefce8", color:"#ca8a04",  label:"Test Resent" },
//   Candidate_Declined:     { bg:"#fdf4ff", color:"#9333ea",  label:"Cand Declined" },
//   Candidate_OnHold:       { bg:"#fff7ed", color:"#ea580c",  label:"Cand On Hold" },
//   Candidate_Quit:         { bg:"#fef2f2", color:"#b91c1c",  label:"Cand Quit" },
//   ScreeningTest_Passed:   { bg:"#f0fdf4", color:"#15803d",  label:"Test Passed" },
//   ReScreeningTest_Passed: { bg:"#dcfce7", color:"#166534",  label:"Re-Test Passed" },
//   OnHold_ReScreening:     { bg:"#fff7ed", color:"#c2410c",  label:"Hold Re-Screen" },
//   OnHold_Screening:       { bg:"#fff7ed", color:"#d97706",  label:"Hold Screening" },
//   TestPassed_Rejected:    { bg:"#fef2f2", color:"#dc2626",  label:"TestPass Rej" },
//   ReTestPassed_Rejected:  { bg:"#fef2f2", color:"#b91c1c",  label:"ReTestPass Rej" },
//   ScreeningTest_Failed:   { bg:"#fef2f2", color:"#dc2626",  label:"Test Failed" },
//   ReScreeningTest_Failed: { bg:"#fee2e2", color:"#991b1b",  label:"Re-Test Failed" },
//   OnHold_TestPassed:      { bg:"#fff7ed", color:"#c2410c",  label:"Hold (Test ✓)" },
//   Interview_Scheduled:    { bg:"#eff6ff", color:"#1d4ed8",  label:"Interview Sched" },
//   Round1_Rejected:        { bg:"#fef2f2", color:"#dc2626",  label:"Round 1 Rej" },
//   Round2_Suggested:       { bg:"#eff6ff", color:"#0369a1",  label:"Round 2 Sugg" },
//   Round2_Scheduled:       { bg:"#dbeafe", color:"#1d4ed8",  label:"Round 2 Sched" },
//   Interviewer_Selected:   { bg:"#f0fdf4", color:"#15803d",  label:"Intrvwr Select" },
//   Interviewer_Rejected:   { bg:"#fef2f2", color:"#dc2626",  label:"Intrvwr Reject" },
//   Selected:               { bg:"#f0fdf4", color:"#15803d",  label:"Selected" },
//   Rejected:               { bg:"#fef2f2", color:"#dc2626",  label:"Rejected" },
//   Shortlisted:            { bg:"#eff6ff", color:"#1d4ed8",  label:"Shortlisted" },
//   Interested:             { bg:"#ecfdf5", color:"#059669",  label:"Interested" },
// };

// const sm = (s) =>
//   STATUS_META[s] || { bg:"#f8fafc", color:"#64748b", label: s?.replace(/_/g," ") || "Unknown" };

// const PERIODS = [
//   { key:"week",    label:"7 Days" },
//   { key:"month",   label:"30 Days" },
//   { key:"quarter", label:"90 Days" },
//   { key:"year",    label:"1 Year" },
//   { key:"custom",  label:"Custom" },
// ];

// // ─── UTILS ───────────────────────────────────────────────────────────────────
// const fmtPct = (n, d) => (d > 0 ? `${((n / d) * 100).toFixed(1)}%` : "0%");
// const fmtPctInt = (n, d) => (d > 0 ? `${((n / d) * 100).toFixed(0)}%` : "0%");
// const nameInitials = (name = "") =>
//   name.split(" ").filter(Boolean).map((w) => w[0]).join("").toUpperCase().slice(0, 2) || "?";

// const sortedStatusEntries = (counts = {}) => {
//   const ordered = STATUS_ORDER.filter((s) => s in counts).map((s) => [s, counts[s]]);
//   const rest = Object.entries(counts).filter(([s]) => !STATUS_ORDER.includes(s));
//   return [...ordered, ...rest];
// };

// // ── KEY FIX: filter "Other" by both id and name ──────────────────────────────
// const isRealRecruiter = (r) =>
//   r.recruiter_id !== "Other" && r.recruiter_name !== "Other" && r.recruiter_id !== "";

// function buildStatusRecruiterMap(jdID, recruiterBreakdown) {
//   const map = {};
//   recruiterBreakdown.filter(isRealRecruiter).forEach((r, ri) => {
//     const jdEntry = (r.jd_breakdown || []).find((j) => j.jdID === jdID);
//     if (!jdEntry) return;
//     const color = PALETTE[ri % PALETTE.length];
//     Object.entries(jdEntry.status_counts || {}).forEach(([status, count]) => {
//       if (!map[status]) map[status] = [];
//       map[status].push({ name: r.recruiter_name, color, count });
//     });
//   });
//   return map;
// }

// // ─── SHARED UI COMPONENTS ────────────────────────────────────────────────────
// const SectionCard = ({ children, sx = {} }) => (
//   <Card elevation={0} sx={{ borderRadius:"16px", border:"1px solid #e2e8f0", background:"#fff", height:"100%", ...sx }}>
//     {children}
//   </Card>
// );

// const SectionHeader = ({ icon, title, subtitle, right }) => (
//   <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={2} flexWrap="wrap" gap={1}>
//     <Box display="flex" alignItems="center" gap={1.5}>
//       <Box sx={{ width:32, height:32, borderRadius:"9px", bgcolor:"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
//         {icon}
//       </Box>
//       <Box>
//         <Typography fontWeight={700} fontSize={13.5} color="#0f172a" lineHeight={1.2}>{title}</Typography>
//         {subtitle && <Typography fontSize={11} color="#94a3b8" mt={0.2}>{subtitle}</Typography>}
//       </Box>
//     </Box>
//     {right}
//   </Box>
// );

// const KpiCard = ({ title, value, icon, accent, sub }) => (
//   <Card elevation={0} sx={{ borderRadius:"14px", border:"1px solid #e2e8f0", height:"100%", overflow:"hidden" }}>
//     <Box sx={{ height:3, background:`linear-gradient(90deg, ${accent}, ${accent}66)` }} />
//     <CardContent sx={{ p:2.5 }}>
//       <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={1.5}>
//         <Box sx={{ width:40, height:40, borderRadius:"11px", bgcolor:`${accent}12`, display:"flex", alignItems:"center", justifyContent:"center" }}>
//           {React.cloneElement(icon, { sx:{ color:accent, fontSize:20 } })}
//         </Box>
//       </Box>
//       <Typography sx={{ fontSize:10, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.08em", mb:0.5 }}>{title}</Typography>
//       <Typography sx={{ fontSize:"1.9rem", fontWeight:800, color:"#0f172a", lineHeight:1 }}>{value ?? 0}</Typography>
//       {sub && <Typography sx={{ fontSize:11, color:"#94a3b8", mt:0.5 }}>{sub}</Typography>}
//     </CardContent>
//   </Card>
// );

// const StatPill = ({ label, val, color, bg }) => (
//   <Box sx={{ px:1.4, py:0.7, borderRadius:"8px", bgcolor:bg, border:`1px solid ${color}22`, textAlign:"center", minWidth:70 }}>
//     <Typography fontWeight={800} fontSize="0.88rem" color={color}>{val}</Typography>
//     <Typography fontSize={9} color={color} fontWeight={600} sx={{ whiteSpace:"nowrap" }}>{label}</Typography>
//   </Box>
// );

// const StatusRow = ({ status, count }) => {
//   const meta = sm(status);
//   return (
//     <Box display="flex" alignItems="center" gap={1.5} sx={{
//       px:1.2, py:0.55, borderRadius:"7px", bgcolor:meta.bg, border:`1px solid ${meta.color}18`, minWidth:160,
//     }}>
//       <FiberManualRecord sx={{ fontSize:6, color:meta.color, flexShrink:0 }} />
//       <Typography fontSize={11} fontWeight={600} color={meta.color} flex={1} noWrap>{meta.label}</Typography>
//       <Typography fontSize={12} fontWeight={800} color={meta.color}>{count}</Typography>
//     </Box>
//   );
// };

// const StatusRowWithRecruiters = ({ status, count, recruiterCounts = [] }) => {
//   const meta = sm(status);
//   const nonZero = recruiterCounts.filter((r) => r.count > 0);
//   const multiRec = nonZero.length > 1;
//   return (
//     <Box display="inline-flex" flexDirection="column" sx={{ minWidth:160, maxWidth:280 }}>
//       <Box display="flex" alignItems="center" gap={1.5} sx={{
//         px:1.2, py:0.55, borderRadius: multiRec ? "7px 7px 0 0" : "7px",
//         bgcolor:meta.bg, border:`1px solid ${meta.color}18`, borderBottom: multiRec ? "none" : undefined,
//       }}>
//         <FiberManualRecord sx={{ fontSize:6, color:meta.color, flexShrink:0 }} />
//         <Typography fontSize={11} fontWeight={600} color={meta.color} flex={1} noWrap>{meta.label}</Typography>
//         <Typography fontSize={12} fontWeight={800} color={meta.color}>{count}</Typography>
//       </Box>
//       {multiRec && (
//         <Box display="flex" flexWrap="wrap" gap={0.4} sx={{
//           px:1.2, py:0.5, bgcolor:`${meta.color}06`,
//           border:`1px solid ${meta.color}18`, borderTop:"none", borderRadius:"0 0 7px 7px",
//         }}>
//           {nonZero.map((r) => (
//             <Tooltip key={r.name} title={`${r.name}: ${r.count}`} placement="top" arrow>
//               <Box display="flex" alignItems="center" gap={0.4} sx={{
//                 px:0.8, py:0.2, borderRadius:"5px", bgcolor:`${r.color}14`, border:`1px solid ${r.color}30`, cursor:"default",
//               }}>
//                 <Box sx={{ width:6, height:6, borderRadius:"50%", bgcolor:r.color }} />
//                 <Typography fontSize={9} fontWeight={700} color={r.color} noWrap>{r.name.split(" ")[0]}: {r.count}</Typography>
//               </Box>
//             </Tooltip>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ─── STATUS DONUT ────────────────────────────────────────────────────────────
// function StatusDonutChart({ teamChartEntries, totalCandidates }) {
//   if (!teamChartEntries.length) return null;
//   const top = teamChartEntries.slice(0, 10);
//   const data = {
//     labels: top.map(([s]) => sm(s).label),
//     datasets: [{ data: top.map(([,v]) => v), backgroundColor: top.map(([s]) => sm(s).color), borderColor:"#fff", borderWidth:3, hoverOffset:8 }],
//   };
//   const options = {
//     responsive:true, maintainAspectRatio:false, cutout:"70%",
//     plugins:{
//       legend:{ display:false },
//       tooltip:{ callbacks:{ label:(ctx)=>` ${ctx.label}: ${ctx.parsed} (${fmtPctInt(ctx.parsed, totalCandidates)})` },
//         backgroundColor:"#0f172a", padding:10, cornerRadius:8, bodyColor:"#f1f5f9" },
//       datalabels:{ display:false },
//     },
//   };
//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5 }}>
//         <SectionHeader icon={<BarChartIcon sx={{ fontSize:15, color:"#6366f1" }} />} title="Pipeline Status Distribution" subtitle={`${totalCandidates} candidates across all stages`} />
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} sm={5}>
//             <Box sx={{ position:"relative", height:210 }}>
//               <Doughnut data={data} options={options} />
//               <Box sx={{ position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", textAlign:"center", pointerEvents:"none" }}>
//                 <Typography fontWeight={800} fontSize={26} color="#0f172a">{totalCandidates}</Typography>
//                 <Typography fontSize={10} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em">Total</Typography>
//               </Box>
//             </Box>
//           </Grid>
//           <Grid item xs={12} sm={7}>
//             <Box display="flex" flexDirection="column" gap={0.8}>
//               {top.map(([status, count]) => {
//                 const meta = sm(status);
//                 const pct = totalCandidates > 0 ? (count/totalCandidates)*100 : 0;
//                 return (
//                   <Box key={status}>
//                     <Box display="flex" alignItems="center" gap={1} mb={0.3}>
//                       <Box sx={{ width:7, height:7, borderRadius:"50%", bgcolor:meta.color, flexShrink:0 }} />
//                       <Typography fontSize={11} color="#374151" flex={1} noWrap>{meta.label}</Typography>
//                       <Typography fontSize={11} fontWeight={700} color="#0f172a">{count}</Typography>
//                       <Typography fontSize={10} color="#94a3b8" sx={{ minWidth:30, textAlign:"right" }}>{pct.toFixed(0)}%</Typography>
//                     </Box>
//                     <LinearProgress variant="determinate" value={pct}
//                       sx={{ height:3, borderRadius:4, bgcolor:`${meta.color}18`, "& .MuiLinearProgress-bar":{ bgcolor:meta.color, borderRadius:4 } }} />
//                   </Box>
//                 );
//               })}
//             </Box>
//           </Grid>
//         </Grid>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── RECRUITER OUTCOME BAR ────────────────────────────────────────────────────
// function RecruiterComparisonChart({ recruiterBreakdown }) {
//   const real = recruiterBreakdown.filter(isRealRecruiter);
//   if (!real.length) return null;
//   const sorted = [...real].sort((a,b) => b.total - a.total);
//   const data = {
//     labels: sorted.map((r) => r.recruiter_name.split(" ")[0]),
//     datasets: [
//       { label:"Selected",    data:sorted.map((r)=>r.selected),    backgroundColor:"#10b981", borderRadius:5, borderSkipped:false },
//       { label:"Rejected",    data:sorted.map((r)=>r.rejected),    backgroundColor:"#ef4444", borderRadius:5, borderSkipped:false },
//       { label:"In Progress", data:sorted.map((r)=>r.in_progress), backgroundColor:"#6366f1", borderRadius:5, borderSkipped:false },
//     ],
//   };
//   const options = {
//     responsive:true, maintainAspectRatio:false,
//     interaction:{ mode:"index", intersect:false },
//     plugins:{
//       legend:{ position:"top", align:"end", labels:{ boxWidth:10, boxHeight:10, font:{ size:11 }, padding:12 } },
//       tooltip:{ backgroundColor:"#0f172a", padding:10, cornerRadius:8, bodyColor:"#f1f5f9" },
//       datalabels:{ display:false },
//     },
//     scales:{
//       x:{ stacked:true, grid:{ display:false }, ticks:{ font:{ size:11 } } },
//       y:{ stacked:true, beginAtZero:true, grid:{ color:"#f8fafc" }, ticks:{ font:{ size:10 }, stepSize:1 } },
//     },
//   };
//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5 }}>
//         <SectionHeader icon={<Groups sx={{ fontSize:15, color:"#10b981" }} />} title="Recruiter Outcome Comparison" subtitle="Selected · Rejected · In Progress — all-time" />
//         <Box sx={{ height:250 }}><Bar data={data} options={options} /></Box>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── SELECTION RATE PIE CHART ─────────────────────────────────────────────────
// function SelectionRatePieChart({ recruiterBreakdown }) {
//   const real = recruiterBreakdown.filter(isRealRecruiter).filter(r => r.total > 0);
//   if (!real.length) return null;
//   const data = {
//     labels: real.map((r) => r.recruiter_name.split(" ")[0]),
//     datasets: [{
//       data: real.map((r) => r.total > 0 ? parseFloat(((r.selected/r.total)*100).toFixed(1)) : 0),
//       backgroundColor: real.map((_, i) => PALETTE[i % PALETTE.length]),
//       borderColor:"#fff", borderWidth:3,
//     }],
//   };
//   const options = {
//     responsive:true, maintainAspectRatio:false,
//     plugins:{
//       legend:{ position:"bottom", labels:{ boxWidth:10, font:{ size:11 } } },
//       tooltip:{ callbacks:{ label:(ctx)=>`${ctx.label}: ${ctx.parsed}% sel rate` },
//         backgroundColor:"#0f172a", padding:10, cornerRadius:8 },
//       datalabels:{ display:false },
//     },
//   };
//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5 }}>
//         <SectionHeader icon={<Verified sx={{ fontSize:15, color:"#10b981" }} />} title="Selection Rate by Recruiter" subtitle="% of candidates selected per recruiter" />
//         <Box sx={{ height:240 }}><Pie data={data} options={options} /></Box>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── RECRUITER RADAR ──────────────────────────────────────────────────────────
// function RecruiterRadarChart({ recruiterBreakdown }) {
//   const real = recruiterBreakdown.filter(isRealRecruiter);
//   if (real.length < 2) return null;
//   const maxVals = {
//     total:    Math.max(...real.map((r)=>r.total),1),
//     selected: Math.max(...real.map((r)=>r.selected),1),
//     jds:      Math.max(...real.map((r)=>r.total_jds||0),1),
//     active:   Math.max(...real.map((r)=>r.in_progress),1),
//   };
//   const datasets = real.map((r, i) => {
//     const selRate = r.total > 0 ? (r.selected/r.total)*100 : 0;
//     return {
//       label: r.recruiter_name.split(" ")[0],
//       data:[
//         (r.total/(maxVals.total))*100,
//         (r.selected/(maxVals.selected))*100,
//         ((r.total_jds||0)/(maxVals.jds))*100,
//         selRate,
//         (r.in_progress/(maxVals.active))*100,
//       ],
//       backgroundColor:`${PALETTE[i%PALETTE.length]}22`,
//       borderColor:PALETTE[i%PALETTE.length],
//       borderWidth:2, pointRadius:4,
//       pointBackgroundColor:PALETTE[i%PALETTE.length],
//     };
//   });
//   const options = {
//     responsive:true, maintainAspectRatio:false,
//     plugins:{
//       legend:{ position:"bottom", labels:{ boxWidth:10, font:{ size:11 } } },
//       datalabels:{ display:false },
//       tooltip:{ callbacks:{ label:(ctx)=>`${ctx.dataset.label}: ${ctx.parsed.r.toFixed(0)}` }, backgroundColor:"#0f172a", padding:10 },
//     },
//     scales:{ r:{ beginAtZero:true, max:100, grid:{ color:"#f1f5f9" }, pointLabels:{ font:{ size:11 } }, ticks:{ display:false } } },
//   };
//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5 }}>
//         <SectionHeader icon={<Speed sx={{ fontSize:15, color:"#8b5cf6" }} />} title="Recruiter Performance Shape" subtitle="Normalized across Volume · Selected · JDs · Sel Rate · Active" />
//         <Box sx={{ height:290 }}><Radar data={{ labels:["Volume","Selected","JDs","Sel Rate","Active"], datasets }} options={options} /></Box>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── TOP PERFORMERS ───────────────────────────────────────────────────────────
// function TopPerformersStrip({ recruiterBreakdown }) {
//   const real = recruiterBreakdown.filter(isRealRecruiter);
//   if (!real.length) return null;
//   const bySelected = [...real].sort((a,b)=>b.selected-a.selected);
//   const bySelRate  = [...real].sort((a,b)=>(b.total>0?b.selected/b.total:0)-(a.total>0?a.selected/a.total:0));
//   const byVolume   = [...real].sort((a,b)=>b.total-a.total);
//   const byActive   = [...real].sort((a,b)=>b.in_progress-a.in_progress);
//   const cols = [
//     { label:"Most Selected",  icon:<EmojiEvents sx={{ fontSize:13, color:"#f59e0b" }}/>, bg:"#fffbeb", color:"#d97706",
//       items:bySelected.slice(0,3).map(r=>({ name:r.recruiter_name, val:`${r.selected} selected` })) },
//     { label:"Best Sel Rate",  icon:<Star sx={{ fontSize:13, color:"#6366f1" }}/>,        bg:"#eef2ff", color:"#6366f1",
//       items:bySelRate.slice(0,3).map(r=>({ name:r.recruiter_name, val:fmtPct(r.selected,r.total) })) },
//     { label:"Top Volume",     icon:<TrendingUp sx={{ fontSize:13, color:"#10b981" }}/>,  bg:"#f0fdf4", color:"#059669",
//       items:byVolume.slice(0,3).map(r=>({ name:r.recruiter_name, val:`${r.total} total` })) },
//     { label:"Most Active",    icon:<Speed sx={{ fontSize:13, color:"#0ea5e9" }}/>,       bg:"#f0f9ff", color:"#0369a1",
//       items:byActive.slice(0,3).map(r=>({ name:r.recruiter_name, val:`${r.in_progress} active` })) },
//   ];
//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5 }}>
//         <SectionHeader icon={<EmojiEvents sx={{ fontSize:15, color:"#f59e0b" }} />} title="Top Performers" subtitle="Ranked by key recruitment metrics" />
//         <Grid container spacing={1.5}>
//           {cols.map((col) => (
//             <Grid item xs={6} md={3} key={col.label}>
//               <Box sx={{ p:1.5, borderRadius:"12px", bgcolor:col.bg, border:`1px solid ${col.color}22`, height:"100%" }}>
//                 <Box display="flex" alignItems="center" gap={0.8} mb={1.2}>{col.icon}<Typography fontSize={11} fontWeight={700} color={col.color}>{col.label}</Typography></Box>
//                 <Box display="flex" flexDirection="column" gap={0.9}>
//                   {col.items.map((item, idx) => (
//                     <Box key={item.name} display="flex" alignItems="center" gap={0.8}>
//                       <Typography fontSize={10} fontWeight={800} color={idx===0?col.color:"#94a3b8"} sx={{ minWidth:14 }}>#{idx+1}</Typography>
//                       <Avatar sx={{ width:20, height:20, fontSize:8, fontWeight:800, bgcolor:idx===0?col.color:"#e2e8f0", color:idx===0?"#fff":"#64748b" }}>{nameInitials(item.name)}</Avatar>
//                       <Box flex={1} minWidth={0}>
//                         <Typography fontSize={11} fontWeight={idx===0?700:500} color="#0f172a" noWrap>{item.name.split(" ")[0]}</Typography>
//                         <Typography fontSize={10} color={col.color} fontWeight={600}>{item.val}</Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── RECRUITER SUMMARY TABLE ──────────────────────────────────────────────────
// function RecruiterSummaryTable({ recruiterBreakdown }) {
//   const real = [...recruiterBreakdown.filter(isRealRecruiter)].sort((a,b)=>b.total-a.total);
//   if (!real.length) return null;
//   const maxTotal = real[0]?.total || 1;
//   return (
//     <SectionCard>
//       <CardContent sx={{ p:0 }}>
//         <Box p={2.5} pb={1.5}>
//           <SectionHeader icon={<People sx={{ fontSize:15, color:"#0ea5e9" }} />} title="All Recruiters — At a Glance" subtitle="Complete pipeline metrics with selection rate indicators" />
//         </Box>
//         <Box sx={{ overflowX:"auto" }}>
//           <Table size="small" sx={{ minWidth:780 }}>
//             <TableHead>
//               <TableRow sx={{ bgcolor:"#f8fafc" }}>
//                 {["#","Recruiter","JDs Assigned","JDs w/ Cands","Total",
//                 // "In Period",
//                 "Selected","Rejected",
//                 // "Active",
//                 "Sel %","Volume"].map((h) => (
//                   <TableCell key={h} align={["#","Recruiter"].includes(h)?"left":"center"}
//                     sx={{ fontWeight:700, fontSize:10, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.05em", py:1.2, px:1.2, whiteSpace:"nowrap" }}>
//                     {h}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {real.map((r, i) => {
//                 const color   = PALETTE[i % PALETTE.length];
//                 const selRate = r.total > 0 ? (r.selected/r.total)*100 : 0;
//                 const volPct  = (r.total/maxTotal)*100;
//                 return (
//                   <TableRow key={r.recruiter_id} hover>
//                     <TableCell sx={{ px:1.2, py:1 }}>
//                       <Box sx={{ width:22, height:22, borderRadius:"50%",
//                         bgcolor:i===0?"#fef3c7":i===1?"#f1f5f9":i===2?"#fde8c8":"#f8fafc",
//                         display:"flex", alignItems:"center", justifyContent:"center" }}>
//                         <Typography fontSize={10} fontWeight={800} color={i===0?"#d97706":i===1?"#94a3b8":i===2?"#b45309":"#cbd5e1"}>{i+1}</Typography>
//                       </Box>
//                     </TableCell>
//                     <TableCell sx={{ px:1.2, py:1 }}>
//                       <Box display="flex" alignItems="center" gap={1}>
//                         <Avatar sx={{ width:28, height:28, fontSize:10, fontWeight:800, bgcolor:color }}>{nameInitials(r.recruiter_name)}</Avatar>
//                         <Box>
//                           <Typography fontSize={12} fontWeight={600} color="#0f172a" noWrap>{r.recruiter_name}</Typography>
//                           <Typography fontSize={10} color="#94a3b8" noWrap>{r.recruiter_email}</Typography>
//                         </Box>
//                       </Box>
//                     </TableCell>
//                     <TableCell align="center" sx={{ px:1.2 }}>
//                       <Chip label={r.total_jds_assigned||r.total_jds||0} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#eff6ff", color:"#2563eb", height:19 }} />
//                     </TableCell>
//                     <TableCell align="center" sx={{ px:1.2 }}>
//                       <Chip label={r.total_jds_with_candidates||0} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#f0fdf4", color:"#15803d", height:19 }} />
//                     </TableCell>
//                     <TableCell align="center" sx={{ px:1.2 }}>
//                       <Typography fontWeight={800} fontSize={13} color="#0f172a">{r.total}</Typography>
//                     </TableCell>
//                     {/* <TableCell align="center" sx={{ px:1.2 }}>
//                       <Chip label={r.ranged_total??0} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:`${color}15`, color, height:19 }} />
//                     </TableCell> */}
//                     <TableCell align="center" sx={{ px:1.2 }}>
//                       <Typography fontWeight={700} fontSize={12} color="#15803d">{r.selected}</Typography>
//                     </TableCell>
//                     <TableCell align="center" sx={{ px:1.2 }}>
//                       <Typography fontWeight={700} fontSize={12} color="#dc2626">{r.rejected}</Typography>
//                     </TableCell>
//                     {/* <TableCell align="center" sx={{ px:1.2 }}>
//                       <Typography fontWeight={700} fontSize={12} color="#c2410c">{r.in_progress}</Typography>
//                     </TableCell> */}
//                     <TableCell align="center" sx={{ px:1.2 }}>
//                       <Box sx={{ display:"inline-flex", alignItems:"center", justifyContent:"center", px:0.9, py:0.2, borderRadius:"6px",
//                         bgcolor:selRate>=30?"#f0fdf4":selRate>=15?"#fefce8":"#fef2f2",
//                         color:selRate>=30?"#15803d":selRate>=15?"#a16207":"#dc2626" }}>
//                         <Typography fontSize={11} fontWeight={800}>{selRate.toFixed(1)}%</Typography>
//                       </Box>
//                     </TableCell>
//                     <TableCell sx={{ px:1.2, minWidth:90 }}>
//                       <LinearProgress variant="determinate" value={volPct}
//                         sx={{ height:6, borderRadius:4, bgcolor:`${color}18`, "& .MuiLinearProgress-bar":{ bgcolor:color, borderRadius:4 } }} />
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </Box>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── JD ROW ──────────────────────────────────────────────────────────────────
// function JdRow({ jd, periodLabel, recruiterBreakdown }) {
//   const [open, setOpen] = useState(false);
//   const entries = sortedStatusEntries(jd.status_counts || {});
//   const statusRecruiterMap = recruiterBreakdown ? buildStatusRecruiterMap(jd.jdID, recruiterBreakdown) : {};
//   return (
//     <>
//       <TableRow hover sx={{ cursor:"pointer", bgcolor:open?"#f8fafc":"inherit" }} onClick={()=>setOpen(o=>!o)}>
//         <TableCell sx={{ pl:3 }}>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Box sx={{ width:26, height:26, borderRadius:"7px", bgcolor:"#eff6ff", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
//               <Work sx={{ color:"#6366f1", fontSize:13 }} />
//             </Box>
//             <Box>
//               <Typography fontWeight={600} fontSize={12} color="#0f172a">{jd.jobRole || "—"}</Typography>
//               <Box display="flex" alignItems="center" gap={0.5}>
//                 <Business sx={{ fontSize:9, color:"#94a3b8" }} />
//                 <Typography fontSize={10} color="#64748b">{jd.companyName}</Typography>
//                 <Typography fontSize={10} color="#6366f1" fontWeight={700} fontFamily="monospace">· {jd.jdID}</Typography>
//               </Box>
//             </Box>
//           </Box>
//         </TableCell>
//         <TableCell align="center"><Typography fontWeight={700} fontSize={13}>{jd.total}</Typography></TableCell>
//         <TableCell align="center"><Chip label={jd.ranged_total??0} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#eff6ff", color:"#6366f1" }} /></TableCell>
//         <TableCell align="center"><Chip label={`${jd.selected} · ${fmtPctInt(jd.selected,jd.total)}`} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#f0fdf4", color:"#15803d" }} /></TableCell>
//         <TableCell align="center"><Chip label={`${jd.rejected} · ${fmtPctInt(jd.rejected,jd.total)}`} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#fef2f2", color:"#dc2626" }} /></TableCell>
//         <TableCell align="center"><Chip label={jd.total-jd.selected-jd.rejected} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#fff7ed", color:"#c2410c" }} /></TableCell>
//         <TableCell align="right" sx={{ pr:2 }}>
//           <IconButton size="small">{open?<KeyboardArrowUp fontSize="small"/>:<KeyboardArrowDown fontSize="small"/>}</IconButton>
//         </TableCell>
//       </TableRow>
//       <TableRow>
//         <TableCell colSpan={7} sx={{ p:0, border:0 }}>
//           <Collapse in={open} timeout="auto" unmountOnExit>
//             <Box sx={{ px:3, py:2, bgcolor:"#f8fafc", borderBottom:"1px solid #f1f5f9" }}>
//               <Typography fontSize={10} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>Status breakdown — {jd.jobRole || jd.jdID}</Typography>
//               {recruiterBreakdown?.filter(isRealRecruiter).length > 1 && (
//                 <Box display="flex" flexWrap="wrap" gap={0.8} mb={1.5}>
//                   {recruiterBreakdown.filter(isRealRecruiter).map((r, ri) => {
//                     const contributed = (r.jd_breakdown||[]).some((j)=>j.jdID===jd.jdID&&j.total>0);
//                     if (!contributed) return null;
//                     return (
//                       <Box key={r.recruiter_id} display="flex" alignItems="center" gap={0.5}>
//                         <Box sx={{ width:8, height:8, borderRadius:"50%", bgcolor:PALETTE[ri%PALETTE.length] }} />
//                         <Typography fontSize={10} color="#64748b">{r.recruiter_name}</Typography>
//                       </Box>
//                     );
//                   })}
//                 </Box>
//               )}
//               <Box display="flex" flexDirection="column" gap={0.8}>
//                 {entries.map(([status, count]) => (
//                   <StatusRowWithRecruiters key={status} status={status} count={count} recruiterCounts={statusRecruiterMap[status]||[]} />
//                 ))}
//               </Box>
//             </Box>
//           </Collapse>
//         </TableCell>
//       </TableRow>
//     </>
//   );
// }

// // ─── JD OVERALL SECTION WITH TABS ────────────────────────────────────────────
// function JdOverallSection({ jdOverall, recruiterBreakdown, periodLabel }) {
//   const [expandedJd, setExpandedJd] = useState(null);
//   const [expandedRecruiterJd, setExpandedRecruiterJd] = useState(null);
//   const [sectionOpen, setSectionOpen] = useState(false);
//   if (!jdOverall.length) return null;
//   const realRecruiters = recruiterBreakdown.filter(isRealRecruiter);

//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5, pb:sectionOpen?2.5:"20px !important" }}>
//         <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}
//           sx={{ cursor:"pointer", userSelect:"none" }} onClick={()=>setSectionOpen(o=>!o)}>
//           <Box display="flex" alignItems="center" gap={1.5}>
//             <Box sx={{ width:32, height:32, borderRadius:"9px", bgcolor:sectionOpen?"#eff6ff":"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", transition:"background 0.2s" }}>
//               <Work sx={{ fontSize:15, color:sectionOpen?"#6366f1":"#64748b" }} />
//             </Box>
//             <Box>
//               <Typography fontWeight={700} fontSize={13.5} color="#0f172a">JD-wise Candidate Breakdown</Typography>
//               <Typography fontSize={11} color="#94a3b8" mt={0.2}>All JDs across all recruiters · expand for status and recruiter splits</Typography>
//             </Box>
//           </Box>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Chip label={`${jdOverall.length} JDs`} size="small" sx={{ fontWeight:700, bgcolor:"#eff6ff", color:"#6366f1" }} />
//             <Chip label={sectionOpen?"Collapse":"Expand"} size="small" sx={{ fontWeight:700, fontSize:10, cursor:"pointer", bgcolor:sectionOpen?"#f1f5f9":"#0f172a", color:sectionOpen?"#475569":"#fff" }} />
//           </Box>
//         </Box>
//         <Collapse in={sectionOpen} timeout="auto" unmountOnExit>
//           <Box mt={2}>
//             <Paper variant="outlined" sx={{ borderRadius:"10px", overflow:"hidden", border:"1px solid #f1f5f9" }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow sx={{ bgcolor:"#f8fafc" }}>
//                     {["","JD / Role","Company","Recruiters","Candidates","In Period","Selected","Rejected","Sel Rate"].map((h) => (
//                       <TableCell key={h} align={["","JD / Role","Company"].includes(h)?"left":"center"}
//                         sx={{ fontWeight:700, fontSize:10, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.04em", py:1.2 }}>{h}</TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {jdOverall.map((jd) => {
//                     const isOpen = expandedJd === jd.jdID;
//                     const entries = sortedStatusEntries(jd.status_counts || {});
//                     const perRecruiter = realRecruiters.map((r,ri) => {
//                       const jdEntry = (r.jd_breakdown||[]).find(j=>j.jdID===jd.jdID);
//                       return jdEntry ? { name:r.recruiter_name, color:PALETTE[ri%PALETTE.length], total:jdEntry.total, ranged:jdEntry.ranged_total??0, selected:jdEntry.selected, rejected:jdEntry.rejected } : null;
//                     }).filter(Boolean).sort((a,b)=>b.total-a.total);
//                     const statusRecruiterMap = buildStatusRecruiterMap(jd.jdID, realRecruiters);
//                     return (
//                       <React.Fragment key={jd.jdID}>
//                         <TableRow hover sx={{ cursor:"pointer", bgcolor:isOpen?"#f0f9ff":"inherit" }} onClick={()=>setExpandedJd(isOpen?null:jd.jdID)}>
//                           <TableCell sx={{ width:36, pl:1.5 }}>
//                             <IconButton size="small" sx={{ p:0.5 }}>
//                               {isOpen?<KeyboardArrowUp fontSize="small"/>:<KeyboardArrowDown fontSize="small"/>}
//                             </IconButton>
//                           </TableCell>
//                           <TableCell>
//                             <Typography fontWeight={600} fontSize={12} color="#0f172a">{jd.jobRole||"—"}</Typography>
//                             <Typography fontSize={10} color="#6366f1" fontWeight={700} fontFamily="monospace">{jd.jdID}</Typography>
//                           </TableCell>
//                           <TableCell><Typography fontSize={11} color="#64748b">{jd.companyName||"—"}</Typography></TableCell>
//                           <TableCell>
//                             <Box display="flex" flexWrap="wrap" gap={0.5}>
//                               {perRecruiter.length===0 ? <Typography fontSize={10} color="#94a3b8">—</Typography>
//                                 : perRecruiter.map((r)=>(
//                                   <Tooltip key={r.name} title={`${r.name} · ${r.total} total · ${r.ranged} in period`}>
//                                     <Typography sx={{ fontSize:10, fontWeight:800, color:r.color, bgcolor:`${r.color}15`, px:1, py:0.25, borderRadius:1, display:"inline-flex", alignItems:"center" }}>{r.name}</Typography>
//                                   </Tooltip>
//                                 ))}
//                             </Box>
//                           </TableCell>
//                           <TableCell align="center"><Typography fontWeight={800} fontSize={14} color="#0f172a">{jd.total}</Typography></TableCell>
//                           <TableCell align="center"><Chip label={jd.ranged_total??0} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#eff6ff", color:"#6366f1" }} /></TableCell>
//                           <TableCell align="center"><Chip label={jd.selected} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#f0fdf4", color:"#15803d" }} /></TableCell>
//                           <TableCell align="center"><Chip label={jd.rejected} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#fef2f2", color:"#dc2626" }} /></TableCell>
//                           <TableCell align="center">
//                             <Typography fontWeight={800} fontSize={12} color={jd.selected>0?"#15803d":"#94a3b8"}>{fmtPctInt(jd.selected,jd.total)}</Typography>
//                           </TableCell>
//                         </TableRow>
//                         <TableRow>
//                           <TableCell colSpan={9} sx={{ p:0, border:0 }}>
//                             <Collapse in={isOpen} timeout="auto" unmountOnExit>
//                               <Box sx={{ bgcolor:"#f8fafc", borderBottom:"1px solid #e2e8f0" }}>
//                                 <Box p={2.5}>
//                                   <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
//                                     <Typography fontSize={10} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em">Status breakdown — {jd.jobRole||jd.jdID}</Typography>
//                                     {perRecruiter.length>1 && (
//                                       <Box display="flex" flexWrap="wrap" gap={0.8}>
//                                         {perRecruiter.map((r)=>(
//                                           <Box key={r.name} display="flex" alignItems="center" gap={0.5}>
//                                             <Box sx={{ width:8, height:8, borderRadius:"50%", bgcolor:r.color }} />
//                                             <Typography fontSize={10} color="#64748b">{r.name}</Typography>
//                                           </Box>
//                                         ))}
//                                       </Box>
//                                     )}
//                                   </Box>
//                                   <Box display="flex" flexDirection="column" gap={0.8}>
//                                     {entries.map(([status, count]) => (
//                                       <StatusRowWithRecruiters key={status} status={status} count={count} recruiterCounts={statusRecruiterMap[status]||[]} />
//                                     ))}
//                                   </Box>
//                                 </Box>
//                                 <Box sx={{ borderTop:"1px solid #f1f5f9" }}>
//                                   <Box display="flex" alignItems="center" justifyContent="space-between" px={2.5} py={1.2}
//                                     sx={{ cursor:"pointer","&:hover":{ bgcolor:"#f1f5f9" } }}
//                                     onClick={(e)=>{ e.stopPropagation(); setExpandedRecruiterJd(prev=>prev===jd.jdID?null:jd.jdID); }}>
//                                     <Box display="flex" alignItems="center" gap={1}>
//                                       <Groups sx={{ fontSize:15, color:"#64748b" }} />
//                                       <Typography fontSize={12} fontWeight={600} color="#374151">Recruiter breakdown</Typography>
//                                       <Chip label={`${perRecruiter.length} recruiter${perRecruiter.length!==1?"s":""}`} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#eff6ff", color:"#6366f1", height:18 }} />
//                                     </Box>
//                                     <IconButton size="small" sx={{ p:0.5 }}>
//                                       {expandedRecruiterJd===jd.jdID?<KeyboardArrowUp fontSize="small"/>:<KeyboardArrowDown fontSize="small"/>}
//                                     </IconButton>
//                                   </Box>
//                                   <Collapse in={expandedRecruiterJd===jd.jdID} timeout="auto" unmountOnExit>
//                                     <Box px={2.5} pb={2.5}>
//                                       {perRecruiter.length===0
//                                         ? <Box display="flex" alignItems="center" justifyContent="center" sx={{ height:60, bgcolor:"#f1f5f9", borderRadius:"8px" }}><Typography fontSize={12} color="#94a3b8">No recruiters assigned</Typography></Box>
//                                         : <Paper variant="outlined" sx={{ borderRadius:"8px", overflow:"hidden", border:"1px solid #e2e8f0" }}>
//                                             <Table size="small">
//                                               <TableHead>
//                                                 <TableRow sx={{ bgcolor:"#f8fafc" }}>
//                                                   {["Recruiter","Candidates","In Period","Selected","Rejected","Sel Rate"].map(h=>(
//                                                     <TableCell key={h} sx={{ fontWeight:700, fontSize:10, color:"#94a3b8", py:0.8, px:1.2 }}>{h}</TableCell>
//                                                   ))}
//                                                 </TableRow>
//                                               </TableHead>
//                                               <TableBody>
//                                                 {perRecruiter.map(r=>(
//                                                   <TableRow key={r.name} hover>
//                                                     <TableCell sx={{ py:0.8, px:1.2 }}>
//                                                       <Box display="flex" alignItems="center" gap={0.8}>
//                                                         <Avatar sx={{ width:22, height:22, fontSize:9, fontWeight:800, bgcolor:r.color }}>{nameInitials(r.name)}</Avatar>
//                                                         <Typography fontSize={11} fontWeight={600} noWrap>{r.name}</Typography>
//                                                       </Box>
//                                                     </TableCell>
//                                                     <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontWeight={700} fontSize={12}>{r.total}</Typography></TableCell>
//                                                     <TableCell sx={{ py:0.8, px:1.2 }}><Chip label={r.ranged} size="small" sx={{ fontWeight:700, fontSize:10, bgcolor:"#eff6ff", color:"#6366f1", height:18 }} /></TableCell>
//                                                     <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontSize={11} color="#15803d" fontWeight={700}>{r.selected}</Typography></TableCell>
//                                                     <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontSize={11} color="#dc2626" fontWeight={700}>{r.rejected}</Typography></TableCell>
//                                                     <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontSize={11} color="#6366f1" fontWeight={700}>{fmtPct(r.selected,r.total)}</Typography></TableCell>
//                                                   </TableRow>
//                                                 ))}
//                                               </TableBody>
//                                             </Table>
//                                           </Paper>
//                                       }
//                                     </Box>
//                                   </Collapse>
//                                 </Box>
//                               </Box>
//                             </Collapse>
//                           </TableCell>
//                         </TableRow>
//                       </React.Fragment>
//                     );
//                   })}
//                 </TableBody>
//               </Table>
//             </Paper>
//           </Box>
//         </Collapse>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── RECRUITER TIMELINE CHART ─────────────────────────────────────────────────
// function RecruiterTimelineChart({ recruiterBreakdown, timelineLabels, periodLabel }) {
//   const [chartType, setChartType]     = useState("line");
//   const [cumulative, setCumulative]   = useState(false);
//   const [hiddenLines, setHiddenLines] = useState({});
//   const realRecruiters = recruiterBreakdown.filter(isRealRecruiter);
//   if (!timelineLabels.length || !realRecruiters.length) return null;
//   if (!realRecruiters.filter(r=>(r.timeline||[]).some(v=>v>0)).length) return null;

//   const formattedLabels = timelineLabels.map(d=>new Date(d).toLocaleDateString("en-IN",{ day:"numeric", month:"short" }));
//   const toCumulative = (arr) => arr.reduce((acc,v,i)=>{ acc.push((acc[i-1]||0)+v); return acc; },[]);

//   const datasets = realRecruiters.map((r,i) => {
//     const color = PALETTE[i%PALETTE.length];
//     const raw   = r.timeline || timelineLabels.map(()=>0);
//     const data  = cumulative ? toCumulative(raw) : raw;
//     return {
//       label:r.recruiter_name, data, hidden:!!hiddenLines[r.recruiter_id],
//       borderColor:color, backgroundColor:chartType==="bar"?`${color}bb`:`${color}18`,
//       fill:chartType==="line", tension:0.4,
//       pointRadius:timelineLabels.length>30?2:4, pointHoverRadius:6,
//       pointBackgroundColor:color, pointBorderColor:"#fff", pointBorderWidth:1.5,
//       borderWidth:chartType==="bar"?1:2, borderRadius:chartType==="bar"?3:0,
//     };
//   });

//   const commonOptions = {
//     responsive:true, maintainAspectRatio:false,
//     interaction:{ mode:"index", intersect:false },
//     plugins:{
//       legend:{ display:false },
//       tooltip:{ callbacks:{ title:items=>items[0]?.label||"", label:ctx=>` ${ctx.dataset.label}: ${ctx.parsed.y} candidate${ctx.parsed.y!==1?"s":""}` },
//         backgroundColor:"#0f172a", titleColor:"#94a3b8", bodyColor:"#f1f5f9", padding:10, cornerRadius:8 },
//       datalabels:{ display:false },
//     },
//     scales:{
//       x:{ grid:{ display:false }, ticks:{ font:{ size:10 }, maxRotation:45, autoSkip:true, maxTicksLimit:14 }, stacked:chartType==="bar" },
//       y:{ beginAtZero:true, grid:{ color:"#f8fafc" }, ticks:{ font:{ size:10 }, stepSize:1, callback:v=>Number.isInteger(v)?v:"" },
//         stacked:chartType==="bar", title:{ display:true, text:cumulative?"Cumulative candidates":"Candidates added", font:{ size:10 }, color:"#94a3b8" } },
//     },
//   };

//   const recruiterTotals = realRecruiters.map(r=>({ ...r, periodTotal:(r.timeline||[]).reduce((s,v)=>s+v,0) })).sort((a,b)=>b.periodTotal-a.periodTotal);
//   const maxPeriodTotal = Math.max(...recruiterTotals.map(r=>r.periodTotal),1);
//   const toggleLine = (rid) => setHiddenLines(prev=>({...prev,[rid]:!prev[rid]}));

//   return (
//     <SectionCard>
//       <CardContent sx={{ p:2.5 }}>
//         <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={1.5} mb={2}>
//           <Box>
//             <Box display="flex" alignItems="center" gap={1} mb={0.3}>
//               <Box sx={{ width:32, height:32, borderRadius:"9px", bgcolor:"#f0f9ff", display:"flex", alignItems:"center", justifyContent:"center" }}>
//                 <Timeline sx={{ fontSize:15, color:"#0ea5e9" }} />
//               </Box>
//               <Typography fontWeight={700} fontSize={13.5} color="#0f172a">Recruiter Intake Timeline</Typography>
//             </Box>
//             <Typography fontSize={11} color="#94a3b8" ml={5}>Candidates added per day · {periodLabel} · click legend to toggle</Typography>
//           </Box>
//           <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
//             <Box display="flex" sx={{ border:"1px solid #e2e8f0", borderRadius:"8px", overflow:"hidden" }}>
//               {[{key:"line",label:"Line"},{key:"bar",label:"Stacked"}].map(({key,label})=>(
//                 <Button key={key} size="small" onClick={()=>setChartType(key)}
//                   sx={{ fontSize:11, fontWeight:600, textTransform:"none", px:1.5, py:0.5, borderRadius:0, minWidth:0,
//                     bgcolor:chartType===key?"#0f172a":"transparent", color:chartType===key?"#fff":"#64748b",
//                     "&:hover":{ bgcolor:chartType===key?"#0f172a":"#f8fafc" } }}>{label}</Button>
//               ))}
//             </Box>
//             <Button size="small" onClick={()=>setCumulative(c=>!c)}
//               sx={{ fontSize:11, fontWeight:600, textTransform:"none", px:1.5, py:0.5, borderRadius:"8px", border:"1px solid #e2e8f0",
//                 bgcolor:cumulative?"#eff6ff":"transparent", color:cumulative?"#6366f1":"#64748b", "&:hover":{ bgcolor:"#f8fafc" } }}>
//               {cumulative?"Cumulative ✓":"Cumulative"}
//             </Button>
//           </Box>
//         </Box>
//         <Grid container spacing={2.5}>
//           <Grid item xs={12} md={9}>
//             <Box sx={{ height:290 }}>
//               {chartType==="line"?<Line data={{ labels:formattedLabels, datasets }} options={commonOptions}/>:<Bar data={{ labels:formattedLabels, datasets }} options={commonOptions}/>}
//             </Box>
//             <Box display="flex" flexWrap="wrap" gap={1} mt={1.5}>
//               {realRecruiters.map((r,i) => {
//                 const color = PALETTE[i%PALETTE.length];
//                 const hidden = !!hiddenLines[r.recruiter_id];
//                 return (
//                   <Box key={r.recruiter_id} display="flex" alignItems="center" gap={0.6} onClick={()=>toggleLine(r.recruiter_id)}
//                     sx={{ px:1.2, py:0.5, borderRadius:"8px", cursor:"pointer", border:`1px solid ${hidden?"#e2e8f0":color+"40"}`,
//                       bgcolor:hidden?"#f8fafc":`${color}0d`, opacity:hidden?0.45:1, transition:"all 0.15s","&:hover":{ opacity:1 } }}>
//                     <Box sx={{ width:10, height:10, borderRadius:"50%", bgcolor:hidden?"#cbd5e1":color }} />
//                     <Typography fontSize={11} fontWeight={600} color={hidden?"#94a3b8":"#374151"} noWrap>{r.recruiter_name}</Typography>
//                   </Box>
//                 );
//               })}
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <Box sx={{ bgcolor:"#f8fafc", borderRadius:"12px", border:"1px solid #f1f5f9", p:1.5, height:"100%" }}>
//               <Typography fontSize={10} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>In Period · Leaderboard</Typography>
//               <Box display="flex" flexDirection="column" gap={1.2}>
//                 {recruiterTotals.map((r,rank) => {
//                   const color = PALETTE[realRecruiters.findIndex(rb=>rb.recruiter_id===r.recruiter_id)%PALETTE.length];
//                   const hidden = !!hiddenLines[r.recruiter_id];
//                   return (
//                     <Box key={r.recruiter_id} onClick={()=>toggleLine(r.recruiter_id)} sx={{ cursor:"pointer", opacity:hidden?0.4:1, transition:"opacity 0.15s" }}>
//                       <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.4}>
//                         <Box display="flex" alignItems="center" gap={0.8}>
//                           <Typography fontSize={10} fontWeight={800} sx={{ width:16, color:rank===0?"#d97706":rank===1?"#64748b":"#94a3b8" }}>#{rank+1}</Typography>
//                           <Avatar sx={{ width:20, height:20, fontSize:8, fontWeight:800, bgcolor:color }}>{nameInitials(r.recruiter_name)}</Avatar>
//                           <Typography fontSize={11} fontWeight={600} color="#374151" noWrap sx={{ maxWidth:90 }}>{r.recruiter_name.split(" ")[0]}</Typography>
//                         </Box>
//                         <Typography fontSize={11} fontWeight={800} color={color}>{r.periodTotal}</Typography>
//                       </Box>
//                       <LinearProgress variant="determinate" value={(r.periodTotal/maxPeriodTotal)*100}
//                         sx={{ height:4, borderRadius:4, bgcolor:`${color}18`, "& .MuiLinearProgress-bar":{ bgcolor:color, borderRadius:4 } }} />
//                     </Box>
//                   );
//                 })}
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>
//       </CardContent>
//     </SectionCard>
//   );
// }

// // ─── PER-RECRUITER CARD WITH JD TABS (Active / Expired) ──────────────────────
// // function RecruiterCard({ recruiter, color, timelineLabels, periodLabel, allRecruiterBreakdown }) {
// //   const { recruiter_name, recruiter_email, total, total_jds, selected, rejected, in_progress,
// //           status_counts, jd_breakdown, timeline } = recruiter;
// function RecruiterCard({ recruiter, color, timelineLabels, periodLabel, allRecruiterBreakdown }) {
//   const { recruiter_name, recruiter_email, total, total_jds, total_jds_assigned, selected, rejected, in_progress,
//           status_counts, jd_breakdown, timeline } = recruiter;
//   const [jdTab, setJdTab] = useState(0);
//   const entries  = sortedStatusEntries(status_counts || {});
//   const selPct   = fmtPct(selected, total);
//   const rejPct   = fmtPct(rejected, total);
//   const selRate  = total > 0 ? (selected/total)*100 : 0;

//   // Separate JDs with candidates (active) vs assigned but no candidates yet (empty)
//   const activeJDs  = (jd_breakdown||[]).filter(jd=>jd.has_candidates!==false && jd.total>0);
//   const emptyJDs   = (jd_breakdown||[]).filter(jd=>jd.has_candidates===false || jd.total===0);
//   const displayJDs = jdTab===0 ? activeJDs : emptyJDs;

//   const chartData = {
//     labels: timelineLabels.map(d=>new Date(d).toLocaleDateString("en-IN",{ day:"numeric", month:"short" })),
//     datasets:[{
//       label:"Candidates added", data:timeline||[], borderColor:color, backgroundColor:`${color}18`,
//       fill:true, tension:0.4, pointRadius:3, pointBackgroundColor:color, pointBorderColor:"#fff", pointBorderWidth:1.5,
//     }],
//   };
//   const chartOptions = {
//     responsive:true, maintainAspectRatio:false,
//     plugins:{ legend:{ display:false }, tooltip:{ callbacks:{ label:ctx=>` ${ctx.parsed.y} candidates added` } }, datalabels:{ display:false } },
//     scales:{
//       x:{ grid:{ display:false }, ticks:{ font:{ size:10 }, maxRotation:45, autoSkip:true, maxTicksLimit:10 } },
//       y:{ beginAtZero:true, grid:{ color:"#f8fafc" }, ticks:{ font:{ size:10 }, stepSize:1, callback:v=>Number.isInteger(v)?v:"" } },
//     },
//   };

//   return (
//     <Accordion elevation={0} sx={{ mb:2, borderRadius:"16px !important", border:"1px solid #e2e8f0", "&:before":{ display:"none" }, "&.Mui-expanded":{ margin:"0 0 16px 0" } }}>
//       <AccordionSummary expandIcon={<ExpandMore />} sx={{ px:2.5, py:1.5, borderRadius:"16px", "&.Mui-expanded":{ borderRadius:"16px 16px 0 0", borderBottom:"1px solid #f1f5f9" } }}>
//         <Box display="flex" alignItems="center" gap={2} flex={1} flexWrap="wrap" pr={1}>
//           <Box sx={{ position:"relative" }}>
//             <Avatar sx={{ width:44, height:44, fontWeight:800, fontSize:14, bgcolor:color }}>{nameInitials(recruiter_name)}</Avatar>
//             {/* {selRate >= 30 && ( */}
//             {total === Math.max(...(allRecruiterBreakdown || []).map(r => r.total)) && total > 0 && (
//               <Box sx={{ position:"absolute", top:-4, right:-4, width:16, height:16, borderRadius:"50%", bgcolor:"#f59e0b", display:"flex", alignItems:"center", justifyContent:"center" }}>
//                 <Star sx={{ fontSize:10, color:"#fff" }} />
//               </Box>
//             )}
//           </Box>
//           <Box flex={1} minWidth={130}>
//             <Typography fontWeight={700} fontSize={14} color="#0f172a">{recruiter_name}</Typography>
//             <Typography fontSize={11} color="#94a3b8">{recruiter_email}</Typography>
//           </Box>
//           <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
//             <StatPill label="Candidates" val={total}                      color={color}   bg={`${color}10`} />
//             {/* <StatPill label="JDs"        val={total_jds||0}               color="#0369a1" bg="#eff6ff"      /> */}
//             <StatPill label="JDs"        val={total_jds_assigned||0}      color="#0369a1" bg="#eff6ff"      />
//             <StatPill label="Selected"   val={`${selected} (${selPct})`}  color="#15803d" bg="#f0fdf4"      />
//             <StatPill label="Rejected"   val={`${rejected} (${rejPct})`}  color="#dc2626" bg="#fef2f2"      />
//             <StatPill label="Active"     val={in_progress}                color="#c2410c" bg="#fff7ed"      />
//           </Box>
//         </Box>
//       </AccordionSummary>

//       <AccordionDetails sx={{ p:0 }}>
//         <Grid container>
//           {/* Pipeline Status */}
//           <Grid item xs={12} md={4} sx={{ borderRight:{ md:"1px solid #f1f5f9" }, borderBottom:{ xs:"1px solid #f1f5f9", md:"none" } }}>
//             <Box p={2.5}>
//               <Typography fontSize={10} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>Pipeline · All Time</Typography>
//               <Box display="flex" flexDirection="column" gap={0.8}>
//                 {entries.map(([status, count]) => <StatusRow key={status} status={status} count={count} />)}
//               </Box>
//               <Divider sx={{ my:2 }} />
//               <Box display="flex" gap={1} justifyContent="space-between">
//                 {[
//                   { label:"Sel Rate", val:selPct,           color:"#15803d", bg:"#f0fdf4" },
//                   { label:"Rej Rate", val:rejPct,           color:"#dc2626", bg:"#fef2f2" },
//                   { label:"Active",   val:`${in_progress}`, color:"#c2410c", bg:"#fff7ed" },
//                 ].map(s=>(
//                   <Box key={s.label} flex={1} textAlign="center" sx={{ p:1, borderRadius:"8px", bgcolor:s.bg }}>
//                     <Typography fontWeight={800} fontSize="0.95rem" color={s.color}>{s.val}</Typography>
//                     <Typography fontSize={9} color={s.color} fontWeight={600}>{s.label}</Typography>
//                   </Box>
//                 ))}
//               </Box>
//             </Box>
//           </Grid>

//           {/* Timeline chart */}
//           <Grid item xs={12} md={8}>
//             <Box p={2.5}>
//               <Typography fontSize={10} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>Candidate Intake · {periodLabel}</Typography>
//               {timelineLabels.length > 0 && (timeline||[]).some(v=>v>0) ? (
//                 <Box sx={{ height:190 }}><Line data={chartData} options={chartOptions} /></Box>
//               ) : (
//                 <Box display="flex" alignItems="center" justifyContent="center" sx={{ height:190, bgcolor:"#f8fafc", borderRadius:"10px" }}>
//                   <Typography fontSize={12} color="#94a3b8">No intake in this period</Typography>
//                 </Box>
//               )}
//             </Box>
//           </Grid>
//         </Grid>

//         {/* JD Drill-Down with Active / Empty tabs */}
//         <Box sx={{ borderTop:"1px solid #f1f5f9" }}>
//           <Box px={2.5} pt={2} pb={0} display="flex" alignItems="center" justifyContent="space-between">
//             <Box>
//               <Typography fontSize={12} fontWeight={700} color="#0f172a">JD Breakdown — click to expand status</Typography>
//               <Typography fontSize={10} color="#94a3b8" mt={0.2}>"In Period" reflects selected window</Typography>
//             </Box>
//             <Box display="flex" gap={1}>
//               <Chip
//                 icon={<AssignmentTurnedIn sx={{ fontSize:12 }} />}
//                 label={`Active (${activeJDs.length})`} size="small"
//                 onClick={()=>setJdTab(0)}
//                 sx={{ fontWeight:700, cursor:"pointer",
//                   bgcolor:jdTab===0?"#10b981":"#f1f5f9",
//                   color:jdTab===0?"#fff":"#64748b", fontSize:10, height:22,
//                   "& .MuiChip-icon":{ color:jdTab===0?"#fff":"#64748b" } }} />
//               <Chip
//                 icon={<WorkOff sx={{ fontSize:12 }} />}
//                 label={`Empty JDs (${emptyJDs.length})`} size="small"
//                 onClick={()=>setJdTab(1)}
//                 sx={{ fontWeight:700, cursor:"pointer",
//                   bgcolor:jdTab===1?"#94a3b8":"#f1f5f9",
//                   color:jdTab===1?"#fff":"#64748b", fontSize:10, height:22,
//                   "& .MuiChip-icon":{ color:jdTab===1?"#fff":"#64748b" } }} />
//             </Box>
//           </Box>

//           {jdTab === 1 && emptyJDs.length > 0 && (
//             <Box px={2.5} py={1.5}>
//               <Alert severity="info" sx={{ borderRadius:"8px", fontSize:11, py:0.5 }}>
//                 These JDs are assigned to {recruiter_name.split(" ")[0]} but have no candidates added yet.
//               </Alert>
//               <Box display="flex" flexWrap="wrap" gap={1} mt={1.5}>
//                 {emptyJDs.map(jd=>(
//                   <Box key={jd.jdID} sx={{ px:1.5, py:1, borderRadius:"8px", border:"1px solid #e2e8f0", bgcolor:"#f8fafc" }}>
//                     <Typography fontSize={11} fontWeight={600} color="#0f172a">{jd.jobRole||"—"}</Typography>
//                     <Typography fontSize={10} color="#6366f1" fontFamily="monospace">{jd.jdID}</Typography>
//                     {jd.companyName && <Typography fontSize={10} color="#94a3b8">{jd.companyName}</Typography>}
//                   </Box>
//                 ))}
//               </Box>
//             </Box>
//           )}

//           {jdTab === 0 && (
//             <Paper variant="outlined" sx={{ mx:0, borderRadius:0, border:"none", borderTop:"1px solid #f1f5f9", overflow:"auto" }}>
//               <Table size="small" sx={{ minWidth:640 }}>
//                 <TableHead>
//                   <TableRow sx={{ bgcolor:"#f8fafc" }}>
//                     {["JD / Role","Candidates","In Period","Selected","Rejected","Active",""].map(h=>(
//                       <TableCell key={h} align={h==="JD / Role"?"left":"center"}
//                         sx={{ fontWeight:700, fontSize:10, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.05em", py:1, pl:h==="JD / Role"?3:1 }}>{h}</TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {displayJDs.length===0
//                     ? <TableRow><TableCell colSpan={7}><Box display="flex" justifyContent="center" py={3}><Typography fontSize={12} color="#94a3b8">No active JDs</Typography></Box></TableCell></TableRow>
//                     : displayJDs.map(jd=>(
//                         <JdRow key={jd.jdID} jd={jd} periodLabel={periodLabel} recruiterBreakdown={allRecruiterBreakdown} />
//                       ))
//                   }
//                 </TableBody>
//               </Table>
//             </Paper>
//           )}
//         </Box>
//       </AccordionDetails>
//     </Accordion>
//   );
// }

// // ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
// export default function RbotManagerDashboard() {
//   const [data,       setData]       = useState(null);
//   const [loading,    setLoading]    = useState(true);
//   const [error,      setError]      = useState("");
//   const [period,     setPeriod]     = useState("month");
//   const [dateFrom,   setDateFrom]   = useState("");
//   const [dateTo,     setDateTo]     = useState("");
//   const [showCustom, setShowCustom] = useState(false);

//   ChartJS.register(ChartDataLabels);

//   const load = useCallback(async (p=period, df=dateFrom, dt=dateTo) => {
//     setLoading(true); setError("");
//     try {
//       let url = `${BASE}/rbot-dashboard/manager?period=${p}`;
//       if (p==="custom"&&df) url += `&date_from=${df}&date_to=${dt||new Date().toISOString().split("T")[0]}`;
//       const res  = await fetch(url,{ headers:getHeaders() });
//       const json = await res.json();
//       if (!json.success) throw new Error(json.message);
//       setData(json);
//     } catch(e) { setError(e.message); } finally { setLoading(false); }
//   }, [period, dateFrom, dateTo]);

//   useEffect(()=>{ load(); },[]); // eslint-disable-line

//   const handlePeriod = (p) => {
//     setPeriod(p); setShowCustom(p==="custom");
//     if (p!=="custom") load(p,"","");
//   };

//   const kpis             = data?.kpis               || {};
//   const teamStatusCounts = data?.team_status_counts || {};
//   const timelineLabels   = data?.timeline_labels    || [];
//   const jdOverall        = data?.jd_overall         || [];
//   const periodLabel      = PERIODS.find(p=>p.key===period)?.label ?? "";

//   // ── THE FIX: filter "Other" here so every child + KPI uses the clean list ──
//   const recruiterBreakdown = (data?.recruiter_breakdown||[]).filter(isRealRecruiter);
//   const teamChartEntries   = sortedStatusEntries(teamStatusCounts);

//   if (loading)
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" flexDirection="column" gap={2}>
//         <CircularProgress size={36} sx={{ color:"#6366f1" }} />
//         <Typography sx={{ color:"#94a3b8", fontSize:13 }}>Loading team analytics…</Typography>
//       </Box>
//     );

//   return (
//     <Box display="flex" flexDirection="column" gap={2.5} pb={4}>
//       {error && <Alert severity="error" onClose={()=>setError("")} sx={{ borderRadius:"12px" }}>{error}</Alert>}

//       {/* ── HERO ── */}
//       <Card elevation={0} sx={{
//         borderRadius:"20px", overflow:"hidden", position:"relative",
//         background:"linear-gradient(135deg, #0f172a 0%, #1e1b4b 45%, #312e81 75%, #4f46e5 100%)",
//       }}>
//         <Box sx={{ position:"absolute", top:-60, right:-60, width:260, height:260, borderRadius:"50%", background:"rgba(99,102,241,0.12)" }} />
//         <Box sx={{ position:"absolute", bottom:-40, right:120, width:160, height:160, borderRadius:"50%", background:"rgba(99,102,241,0.08)" }} />
//         <CardContent sx={{ p:3, position:"relative" }}>
//           <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2}>
//             <Box>
//               <Typography sx={{ color:"rgba(165,180,252,0.8)", fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.12em", mb:0.5 }}>
//                 ResourcingBot · Manager Console
//               </Typography>
//               <Typography sx={{ color:"#fff", fontWeight:800, fontSize:"1.7rem", lineHeight:1.2, mb:1.5 }}>
//                 Recruiter Analytics Dashboard
//               </Typography>
//               <Box display="flex" gap={1} flexWrap="wrap">
//                 {[
//                   { icon:<Groups sx={{ fontSize:12 }}/>,      label:`${recruiterBreakdown.length} Recruiters` },
//                   { icon:<People sx={{ fontSize:12 }}/>,      label:`${kpis.total??0} Candidates` },
//                   { icon:<CheckCircle sx={{ fontSize:12 }}/>, label:`${kpis.selected??0} Selected` },
//                   { icon:<Cancel sx={{ fontSize:12 }}/>,      label:`${kpis.rejected??0} Rejected` },
//                   { icon:<Timeline sx={{ fontSize:12 }}/>,    label:`${kpis.ranged_total??0} in ${periodLabel}` },
//                 ].map(({icon,label})=>(
//                   <Chip key={label}
//                     icon={React.cloneElement(icon,{ style:{ color:"rgba(165,180,252,0.9)" } })}
//                     label={label} size="small"
//                     sx={{ bgcolor:"rgba(99,102,241,0.18)", color:"#e0e7ff", fontWeight:600, fontSize:11,
//                       border:"1px solid rgba(99,102,241,0.35)", "& .MuiChip-icon":{ ml:0.8 } }} />
//                 ))}
//               </Box>
//             </Box>
//             <Box display="flex" flexDirection="column" gap={1} alignItems="flex-end">
//               <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="flex-end">
//                 {PERIODS.map(p=>(
//                   <Button key={p.key} size="small" onClick={()=>handlePeriod(p.key)}
//                     sx={{ fontSize:11, fontWeight:600, textTransform:"none", px:1.5, py:0.5, borderRadius:"8px", minWidth:0,
//                       color:period===p.key?"#0f172a":"rgba(255,255,255,0.7)",
//                       bgcolor:period===p.key?"#fff":"rgba(255,255,255,0.08)",
//                       border:"1px solid", borderColor:period===p.key?"#fff":"rgba(255,255,255,0.15)",
//                       "&:hover":{ bgcolor:period===p.key?"#f1f5f9":"rgba(255,255,255,0.15)" } }}>{p.label}</Button>
//                 ))}
//                 <Tooltip title="Refresh data">
//                   <IconButton size="small" onClick={()=>load()}
//                     sx={{ color:"rgba(255,255,255,0.7)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:"8px", p:0.7, ml:0.5, "&:hover":{ bgcolor:"rgba(255,255,255,0.1)" } }}>
//                     <Refresh fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//               {showCustom && (
//                 <Box display="flex" gap={1} alignItems="center" flexWrap="wrap" justifyContent="flex-end">
//                   <TextField size="small" type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)}
//                     sx={{ width:140, "& .MuiInputBase-root":{ bgcolor:"rgba(255,255,255,0.08)", color:"#fff", fontSize:11, borderRadius:"8px" },
//                       "& .MuiOutlinedInput-notchedOutline":{ borderColor:"rgba(255,255,255,0.2)" } }} />
//                   <Typography color="rgba(255,255,255,0.4)" fontSize={11}>to</Typography>
//                   <TextField size="small" type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)}
//                     sx={{ width:140, "& .MuiInputBase-root":{ bgcolor:"rgba(255,255,255,0.08)", color:"#fff", fontSize:11, borderRadius:"8px" },
//                       "& .MuiOutlinedInput-notchedOutline":{ borderColor:"rgba(255,255,255,0.2)" } }} />
//                   <Button size="small" onClick={()=>load("custom",dateFrom,dateTo)}
//                     sx={{ bgcolor:"#6366f1", color:"#fff", fontWeight:700, fontSize:11, textTransform:"none", borderRadius:"8px","&:hover":{ bgcolor:"#4f46e5" } }}>
//                     Apply
//                   </Button>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* ── KPI STRIP — uses recruiterBreakdown.length (already filtered) ── */}
//       <Grid container spacing={2}>
//         {[
//           { title:"Total Candidates",  value:kpis.total,               icon:<People />,      accent:"#6366f1" },
//           { title:`In ${periodLabel}`, value:kpis.ranged_total,        icon:<Timeline />,    accent:"#0ea5e9", sub:"New in selected period" },
//           { title:"Selected",          value:kpis.selected,            icon:<CheckCircle />, accent:"#10b981", sub:fmtPct(kpis.selected,kpis.total)+" sel rate" },
//           { title:"Rejected",          value:kpis.rejected,            icon:<Cancel />,      accent:"#ef4444", sub:fmtPct(kpis.rejected,kpis.total)+" rej rate" },
//           // ← FIX: use filtered array length, not kpis.total_recruiters
//           { title:"Recruiters",        value:recruiterBreakdown.length, icon:<Groups />,      accent:"#f59e0b" },
//         ].map(c=>(
//           <Grid item xs={6} sm={4} md={12/5} key={c.title}><KpiCard {...c} /></Grid>
//         ))}
//       </Grid>

//       {/* ── TOP PERFORMERS ── */}
//       <TopPerformersStrip recruiterBreakdown={recruiterBreakdown} />

//       {/* ── CHARTS ROW: Donut + Outcome Bar ── */}
//       <Grid container spacing={2}>
//         <Grid item xs={12} md={5}>
//           <StatusDonutChart teamChartEntries={teamChartEntries} totalCandidates={kpis.total??0} />
//         </Grid>
//         <Grid item xs={12} md={7}>
//           <RecruiterComparisonChart recruiterBreakdown={recruiterBreakdown} />
//         </Grid>
//       </Grid>

//       {/* ── RECRUITER TABLE ── */}
//       <RecruiterSummaryTable recruiterBreakdown={recruiterBreakdown} />

//       {/* ── RADAR + SELECTION RATE PIE ── */}
//       {recruiterBreakdown.filter(isRealRecruiter).length >= 2 && (
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={6}>
//             <RecruiterRadarChart recruiterBreakdown={recruiterBreakdown} />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <SelectionRatePieChart recruiterBreakdown={recruiterBreakdown} />
//           </Grid>
//         </Grid>
//       )}

//       {/* ── TIMELINE ── */}
//       <RecruiterTimelineChart recruiterBreakdown={recruiterBreakdown} timelineLabels={timelineLabels} periodLabel={periodLabel} />

//       {/* ── JD OVERALL ── */}
//       <JdOverallSection jdOverall={jdOverall} recruiterBreakdown={recruiterBreakdown} periodLabel={periodLabel} />

//       {/* ── PER-RECRUITER DEEP DIVE ── */}
//       <Box>
//         <Box mb={2}>
//           <Box display="flex" alignItems="center" gap={1.5} mb={0.4}>
//             <Box sx={{ width:4, height:22, borderRadius:2, bgcolor:"#6366f1" }} />
//             <Typography fontWeight={800} fontSize={17} color="#0f172a">Per-Recruiter Deep Dive</Typography>
//           </Box>
//           <Typography fontSize={12} color="#94a3b8" ml={2}>
//             Expand each recruiter — pipeline status · active JDs · empty JDs · daily intake chart
//           </Typography>
//         </Box>
//         {recruiterBreakdown.length===0
//           ? <SectionCard><Box display="flex" justifyContent="center" alignItems="center" py={8}><Typography color="text.secondary" fontSize={13}>No recruiter data found</Typography></Box></SectionCard>
//           : recruiterBreakdown.map((r,i)=>(
//               <RecruiterCard key={r.recruiter_id} recruiter={r} color={PALETTE[i%PALETTE.length]}
//                 timelineLabels={timelineLabels} periodLabel={periodLabel} allRecruiterBreakdown={recruiterBreakdown} />
//             ))
//         }
//       </Box>
//     </Box>
//   );
// }

























import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box, Grid, Card, CardContent, Typography, Chip, CircularProgress,
  Alert, LinearProgress, Table, TableHead, TableBody, TableRow,
  TableCell, Paper, Avatar, Accordion, AccordionSummary,
  AccordionDetails, Divider, Button, TextField,
  Collapse, IconButton, Tooltip, Tab, Tabs,
} from "@mui/material";
import {
  People, CheckCircle, Cancel, Groups, ExpandMore,
  Work, Business, FiberManualRecord,
  KeyboardArrowDown, KeyboardArrowUp,
  Timeline, Refresh, TrendingUp, TrendingDown,
  EmojiEvents, Star, Speed, BarChart as BarChartIcon,
  Assignment, AssignmentTurnedIn, HourglassEmpty,
  WorkOff, Verified, FilterAlt,
} from "@mui/icons-material";
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement, LineElement,
  PointElement, ArcElement, RadialLinearScale,
  Title, Tooltip as ChartTooltip, Legend, Filler,
} from "chart.js";
import { Bar, Line, Radar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { ThemeProvider } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import recruiterTheme, {
  FONT_BODY, FONT_DISPLAY, FONT_MONO, TYPE, RADIUS, SHADOW, PAGE_PADDING, CONTROL_HEIGHT,
} from "../../styles/recruiterTheme";

ChartJS.register(
  CategoryScale, LinearScale, BarElement, LineElement,
  PointElement, ArcElement, RadialLinearScale,
  Title, ChartTooltip, Legend, Filler, ChartDataLabels
);

// ─── CONFIG ──────────────────────────────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL;
const pad2 = (n) => String(n).padStart(2, "0");
const todayLocal = () => { const d = new Date(); return `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`; };
const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

const PALETTE = [
  "#6366f1", "#0ea5e9", "#10b981", "#f59e0b",
  "#ef4444", "#8b5cf6", "#ec4899", "#14b8a6",
];

const STATUS_ORDER = [
  "NewCandidate",
  "Recruiter_Rejected","Recruiter_Accepted","Recruiter_Hold",
  "HiringManager_Rejected","HiringManager_Accepted","HiringManager_Hold",
  "ScreeningTest_Sent","ScreeningTest_Resent",
  "Candidate_Declined","Candidate_OnHold","Candidate_Quit",
  "ScreeningTest_Passed","ReScreeningTest_Passed",
  "OnHold_ReScreening","OnHold_Screening",
  "TestPassed_Rejected","ReTestPassed_Rejected",
  "ScreeningTest_Failed","ReScreeningTest_Failed",
  "OnHold_TestPassed",
  "Interview_Scheduled","Round1_Rejected","Round2_Suggested",
  "Round2_Scheduled","Interviewer_Selected","Interviewer_Rejected",
  "Selected","Rejected",
];

const STATUS_META = {
  NewCandidate:           { bg:"#f1f5f9", color:"#475569",  label:"New Candidate" },
  Recruiter_Rejected:     { bg:"#fef2f2", color:"#dc2626",  label:"Rctr Rejected" },
  Recruiter_Accepted:     { bg:"#eff6ff", color:"#2563eb",  label:"Rctr Accepted" },
  Recruiter_Hold:         { bg:"#fff7ed", color:"#c2410c",  label:"Rctr Hold" },
  HiringManager_Rejected: { bg:"#fef2f2", color:"#991b1b",  label:"HM Rejected" },
  HiringManager_Accepted: { bg:"#f0fdf4", color:"#166534",  label:"HM Accepted" },
  HiringManager_Hold:     { bg:"#fff7ed", color:"#b45309",  label:"HM Hold" },
  ScreeningTest_Sent:     { bg:"#fefce8", color:"#a16207",  label:"Test Sent" },
  ScreeningTest_Resent:   { bg:"#fefce8", color:"#ca8a04",  label:"Test Resent" },
  Candidate_Declined:     { bg:"#fdf4ff", color:"#9333ea",  label:"Cand Declined" },
  Candidate_OnHold:       { bg:"#fff7ed", color:"#ea580c",  label:"Cand On Hold" },
  Candidate_Quit:         { bg:"#fef2f2", color:"#b91c1c",  label:"Cand Quit" },
  ScreeningTest_Passed:   { bg:"#f0fdf4", color:"#15803d",  label:"Test Passed" },
  ReScreeningTest_Passed: { bg:"#dcfce7", color:"#166534",  label:"Re-Test Passed" },
  OnHold_ReScreening:     { bg:"#fff7ed", color:"#c2410c",  label:"Hold Re-Screen" },
  OnHold_Screening:       { bg:"#fff7ed", color:"#d97706",  label:"Hold Screening" },
  TestPassed_Rejected:    { bg:"#fef2f2", color:"#dc2626",  label:"TestPass Rej" },
  ReTestPassed_Rejected:  { bg:"#fef2f2", color:"#b91c1c",  label:"ReTestPass Rej" },
  ScreeningTest_Failed:   { bg:"#fef2f2", color:"#dc2626",  label:"Test Failed" },
  ReScreeningTest_Failed: { bg:"#fee2e2", color:"#991b1b",  label:"Re-Test Failed" },
  OnHold_TestPassed:      { bg:"#fff7ed", color:"#c2410c",  label:"Hold (Test ✓)" },
  Interview_Scheduled:    { bg:"#eff6ff", color:"#1d4ed8",  label:"Interview Sched" },
  Round1_Rejected:        { bg:"#fef2f2", color:"#dc2626",  label:"Round 1 Rej" },
  Round2_Suggested:       { bg:"#eff6ff", color:"#0369a1",  label:"Round 2 Sugg" },
  Round2_Scheduled:       { bg:"#dbeafe", color:"#1d4ed8",  label:"Round 2 Sched" },
  Interviewer_Selected:   { bg:"#f0fdf4", color:"#15803d",  label:"Intrvwr Select" },
  Interviewer_Rejected:   { bg:"#fef2f2", color:"#dc2626",  label:"Intrvwr Reject" },
  Selected:               { bg:"#f0fdf4", color:"#15803d",  label:"Selected" },
  Rejected:               { bg:"#fef2f2", color:"#dc2626",  label:"Rejected" },
  Shortlisted:            { bg:"#eff6ff", color:"#1d4ed8",  label:"Shortlisted" },
  Interested:             { bg:"#ecfdf5", color:"#059669",  label:"Interested" },
};

const sm = (s) =>
  STATUS_META[s] || { bg:"#f8fafc", color:"#64748b", label: s?.replace(/_/g," ") || "Unknown" };

const PERIODS = [
  { key:"week",    label:"7 Days" },
  { key:"month",   label:"30 Days" },
  { key:"quarter", label:"90 Days" },
  { key:"year",    label:"1 Year" },
  { key:"custom",  label:"Custom" },
];

// ─── FUNNEL STAGE MODEL ───────────────────────────────────────────────────────
// "Reached-at-least" counting: each stage counts every candidate who advanced to
// at least that step, so the funnel decreases monotonically. Each raw status maps
// to the FURTHEST stage it implies a candidate reached; the candidate is then
// credited to that stage and every stage above it.
//
// AUDIT THIS MAP against your real process. To move a status between stages,
// change its number on its line.
// Stages: 1 Applied · 2 Recruiter · 3 HM · 4 Test · 5 Interview · 6 Selected
const FURTHEST_STAGE = {
  NewCandidate:            1,
  Recruiter_Rejected:      1,   // exited at recruiter step
  Rejected:                1,   // terminal reject, no stage signal

  Recruiter_Accepted:      2,
  Recruiter_Hold:          2,
  HiringManager_Rejected:  2,   // exited at HM step → reached recruiter

  HiringManager_Accepted:  3,
  HiringManager_Hold:      3,

  ScreeningTest_Sent:      4,
  ScreeningTest_Resent:    4,
  Candidate_Declined:      4,
  Candidate_OnHold:        4,
  Candidate_Quit:          4,
  ScreeningTest_Passed:    4,
  ReScreeningTest_Passed:  4,
  OnHold_ReScreening:      4,
  OnHold_Screening:        4,
  TestPassed_Rejected:     4,
  ReTestPassed_Rejected:   4,
  ScreeningTest_Failed:    4,
  ReScreeningTest_Failed:  4,
  OnHold_TestPassed:       4,

  Interview_Scheduled:     5,
  Round1_Rejected:         5,
  Round2_Suggested:        5,
  Round2_Scheduled:        5,
  Interviewer_Selected:    5,
  Interviewer_Rejected:    5,

  Selected:                6,
};

const FUNNEL_STAGES = [
  { key: "applied",   label: "Applied",          color: "#6366f1" },
  { key: "recruiter", label: "Recruiter Screen", color: "#0ea5e9" },
  { key: "hm",        label: "HM Review",        color: "#14b8a6" },
  { key: "test",      label: "Screening Test",   color: "#f59e0b" },
  { key: "interview", label: "Interview",        color: "#8b5cf6" },
  { key: "selected",  label: "Selected",         color: "#10b981" },
];

// Turn raw {status: count} into cumulative per-stage totals.
function buildFunnel(statusCounts = {}) {
  const reached = [0, 0, 0, 0, 0, 0]; // index 0..5 → stage 1..6
  Object.entries(statusCounts).forEach(([status, count]) => {
    const furthest = FURTHEST_STAGE[status] ?? 1; // unknown status → counts as applied
    for (let s = 0; s < furthest; s++) reached[s] += count;
  });
  const applied = reached[0] || 0;
  return FUNNEL_STAGES.map((stage, i) => ({
    ...stage,
    value: reached[i],
    pctOfTop:  applied > 0 ? (reached[i] / applied) * 100 : 0,
    pctOfPrev: i === 0 ? 100 : (reached[i - 1] > 0 ? (reached[i] / reached[i - 1]) * 100 : 0),
    dropFromPrev: i === 0 ? 0 : Math.max(0, reached[i - 1] - reached[i]),
  }));
}

// ─── UTILS ───────────────────────────────────────────────────────────────────
const fmtPct = (n, d) => (d > 0 ? `${((n / d) * 100).toFixed(1)}%` : "0%");
const fmtPctInt = (n, d) => (d > 0 ? `${((n / d) * 100).toFixed(0)}%` : "0%");
const nameInitials = (name = "") =>
  name.split(" ").filter(Boolean).map((w) => w[0]).join("").toUpperCase().slice(0, 2) || "?";

const sortedStatusEntries = (counts = {}) => {
  const ordered = STATUS_ORDER.filter((s) => s in counts).map((s) => [s, counts[s]]);
  const rest = Object.entries(counts).filter(([s]) => !STATUS_ORDER.includes(s));
  return [...ordered, ...rest];
};

// ── KEY FIX: filter "Other" by both id and name ──────────────────────────────
const isRealRecruiter = (r) =>
  r.recruiter_id !== "Other" && r.recruiter_name !== "Other" && r.recruiter_id !== "";

function buildStatusRecruiterMap(jdID, recruiterBreakdown) {
  const map = {};
  recruiterBreakdown.filter(isRealRecruiter).forEach((r, ri) => {
    const jdEntry = (r.jd_breakdown || []).find((j) => j.jdID === jdID);
    if (!jdEntry) return;
    const color = PALETTE[ri % PALETTE.length];
    Object.entries(jdEntry.status_counts || {}).forEach(([status, count]) => {
      if (!map[status]) map[status] = [];
      map[status].push({ name: r.recruiter_name, color, count });
    });
  });
  return map;
}

// ─── SHARED UI COMPONENTS ────────────────────────────────────────────────────
// Typography helpers (presentation only): one font, the shared type scale, tabular digits.
const NUM = { fontFamily: FONT_BODY, fontVariantNumeric: "tabular-nums" };
const OVERLINE_SX = { fontFamily: FONT_BODY, fontSize: TYPE.overline, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em" };
const HEAD_CELL_SX = { ...OVERLINE_SX, whiteSpace: "nowrap", py: 1.25, px: 1.5 };
const MINI_CHIP_SX = { fontFamily: FONT_BODY, fontWeight: 700, fontSize: TYPE.caption, height: 24, borderRadius: `${RADIUS.sm}px`, ...NUM };
const chartFont = (size = TYPE.caption, weight) => ({ family: FONT_BODY, size, ...(weight ? { weight } : {}) });

const SectionCard = ({ children, sx = {} }) => (
  <Card elevation={0} sx={{ borderRadius:`${RADIUS.lg}px`, border:"1px solid #e2e8f0", background:"#fff", boxShadow:SHADOW.card, height:"100%", fontFamily:FONT_BODY, ...sx }}>
    {children}
  </Card>
);

const SectionHeader = ({ icon, title, subtitle, right }) => (
  <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} flexWrap="wrap" gap={1}>
    <Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
      <Box sx={{ width:32, height:32, borderRadius:`${RADIUS.sm}px`, bgcolor:"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
        {icon}
      </Box>
      <Box minWidth={0}>
        <Typography sx={{ fontFamily:FONT_BODY, fontWeight:700, fontSize:TYPE.cardTitle, color:"#0f172a", lineHeight:1.3 }}>{title}</Typography>
        {subtitle && <Typography sx={{ fontFamily:FONT_BODY, fontSize:TYPE.caption, color:"#94a3b8", mt:0.25, lineHeight:1.4 }}>{subtitle}</Typography>}
      </Box>
    </Box>
    {right}
  </Box>
);

const KpiCard = ({ title, value, icon, accent, sub }) => (
  <Card elevation={0} sx={{ borderRadius:`${RADIUS.md}px`, border:"1px solid #e2e8f0", boxShadow:SHADOW.card, height:"100%", overflow:"hidden", display:"flex", flexDirection:"column" }}>
    <Box sx={{ height:3, flexShrink:0, background:`linear-gradient(90deg, ${accent}, ${accent}66)` }} />
    <Box sx={{ flex:1, display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:1.5, px:2.5, py:2, minHeight:96 }}>
      <Box minWidth={0}>
        {/* Labels may wrap to two lines; reserving both lines keeps numbers aligned across the row. */}
        <Typography sx={{ ...OVERLINE_SX, mb:0.5, lineHeight:1.3, minHeight:"2.6em", display:"flex", alignItems:"flex-end" }}>{title}</Typography>
        <Typography sx={{ ...NUM, fontSize:TYPE.stat, fontWeight:800, color:"#0f172a", lineHeight:1.1 }}>{value ?? 0}</Typography>
        {sub && <Typography sx={{ fontFamily:FONT_BODY, fontSize:TYPE.caption, color:"#94a3b8", mt:0.5, lineHeight:1.4 }}>{sub}</Typography>}
      </Box>
      <Box sx={{ width:40, height:40, flexShrink:0, borderRadius:`${RADIUS.md}px`, bgcolor:`${accent}12`, display:"flex", alignItems:"center", justifyContent:"center" }}>
        {React.cloneElement(icon, { sx:{ color:accent, fontSize:20 } })}
      </Box>
    </Box>
  </Card>
);

const StatPill = ({ label, val, color, bg }) => (
  <Box sx={{ px:1.5, py:0.75, borderRadius:`${RADIUS.sm}px`, bgcolor:bg, border:`1px solid ${color}22`, textAlign:"center", minWidth:72 }}>
    <Typography sx={{ ...NUM, fontWeight:800, fontSize:TYPE.body, color, lineHeight:1.3 }}>{val}</Typography>
    <Typography sx={{ fontFamily:FONT_BODY, fontSize:TYPE.overline, color, fontWeight:600, whiteSpace:"nowrap" }}>{label}</Typography>
  </Box>
);

const StatusRow = ({ status, count }) => {
  const meta = sm(status);
  return (
    <Box display="flex" alignItems="center" gap={1.5} sx={{
      px:1.5, py:0.75, borderRadius:`${RADIUS.sm}px`, bgcolor:meta.bg, border:`1px solid ${meta.color}18`, minWidth:160,
    }}>
      <FiberManualRecord sx={{ fontSize:6, color:meta.color, flexShrink:0 }} />
      <Typography sx={{ fontFamily:FONT_BODY, fontSize:TYPE.caption, fontWeight:600, color:meta.color, flex:1 }} noWrap>{meta.label}</Typography>
      <Typography sx={{ ...NUM, fontSize:TYPE.small, fontWeight:800, color:meta.color }}>{count}</Typography>
    </Box>
  );
};

const StatusRowWithRecruiters = ({ status, count, recruiterCounts = [] }) => {
  const meta = sm(status);
  const nonZero = recruiterCounts.filter((r) => r.count > 0);
  const multiRec = nonZero.length > 1;
  return (
    <Box display="inline-flex" flexDirection="column" sx={{ minWidth:160, maxWidth:280 }}>
      <Box display="flex" alignItems="center" gap={1.5} sx={{
        px:1.5, py:0.75, borderRadius: multiRec ? `${RADIUS.sm}px ${RADIUS.sm}px 0 0` : `${RADIUS.sm}px`,
        bgcolor:meta.bg, border:`1px solid ${meta.color}18`, borderBottom: multiRec ? "none" : undefined,
      }}>
        <FiberManualRecord sx={{ fontSize:6, color:meta.color, flexShrink:0 }} />
        <Typography sx={{ fontFamily:FONT_BODY, fontSize:TYPE.caption, fontWeight:600, color:meta.color, flex:1 }} noWrap>{meta.label}</Typography>
        <Typography sx={{ ...NUM, fontSize:TYPE.small, fontWeight:800, color:meta.color }}>{count}</Typography>
      </Box>
      {multiRec && (
        <Box display="flex" flexWrap="wrap" gap={0.5} sx={{
          px:1.5, py:0.5, bgcolor:`${meta.color}06`,
          border:`1px solid ${meta.color}18`, borderTop:"none", borderRadius:`0 0 ${RADIUS.sm}px ${RADIUS.sm}px`,
        }}>
          {nonZero.map((r) => (
            <Tooltip key={r.name} title={`${r.name}: ${r.count}`} placement="top" arrow>
              <Box display="flex" alignItems="center" gap={0.5} sx={{
                px:1, py:0.25, borderRadius:`${RADIUS.sm}px`, bgcolor:`${r.color}14`, border:`1px solid ${r.color}30`, cursor:"default",
              }}>
                <Box sx={{ width:6, height:6, borderRadius:"50%", bgcolor:r.color }} />
                <Typography sx={{ ...NUM, fontSize:TYPE.overline, fontWeight:700, color:r.color }} noWrap>{r.name.split(" ")[0]}: {r.count}</Typography>
              </Box>
            </Tooltip>
          ))}
        </Box>
      )}
    </Box>
  );
};

// ─── PIPELINE CONVERSION FUNNEL (custom SVG) ──────────────────────────────────
// Stage labels sit in their own left column and counts in a right column, so the
// text never depends on (or gets clipped by) the width of the band itself.
function PipelineFunnelChart({ teamStatusCounts, totalCandidates }) {
  const rows = buildFunnel(teamStatusCounts);
  const top = rows[0].value || 1;

  // Geometry
  const W = 400;                 // svg logical width
  const labelW = 120;            // left column: stage labels
  const valueW = 48;             // right column: counts
  const colGap = 12;
  const FX = labelW + colGap;    // funnel area start
  const FW = W - labelW - valueW - colGap * 2; // funnel area width
  const bandH = 36;              // height of each trapezoid band
  const gap = 8;                 // vertical gap between bands
  const minWidthRatio = 0.14;    // never let the narrowest band vanish
  const H = rows.length * bandH + (rows.length - 1) * gap;

  const widthFor = (v) => {
    const r = top > 0 ? v / top : 0;
    return (minWidthRatio + (1 - minWidthRatio) * r) * FW;
  };
  const cx = FX + FW / 2;

  return (
    <SectionCard>
      <CardContent sx={{ p: 3 }}>
        <SectionHeader
          icon={<BarChartIcon sx={{ fontSize: 16, color: "#6366f1" }} />}
          title="Pipeline Conversion Funnel"
          subtitle={`${totalCandidates} applied · ${rows[rows.length - 1].pctOfTop.toFixed(1)}% reach selection`}
        />

        <Box display="flex" flexDirection="column" gap={2}>
          {/* Funnel diagram */}
          <Box sx={{ width: "100%", maxWidth: 480, mx: "auto" }}>
            <svg viewBox={`0 0 ${W} ${H}`} width="100%" role="img"
                 aria-label="Recruitment pipeline funnel"
                 style={{ display: "block", overflow: "visible", fontFamily: FONT_BODY }}>
              <defs>
                {rows.map((r) => (
                  <linearGradient key={r.key} id={`fnl-${r.key}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%"  stopColor={r.color} stopOpacity="0.95" />
                    <stop offset="100%" stopColor={r.color} stopOpacity="0.72" />
                  </linearGradient>
                ))}
              </defs>

              {rows.map((r, i) => {
                const yTop = i * (bandH + gap);
                const yMid = yTop + bandH / 2;
                const wTop = widthFor(r.value);
                const wBot = widthFor(rows[i + 1] ? rows[i + 1].value : r.value);
                const xTopL = cx - wTop / 2;
                const xTopR = cx + wTop / 2;
                const xBotL = cx - wBot / 2;
                const xBotR = cx + wBot / 2;
                const isLast = i === rows.length - 1;

                const pts = isLast
                  ? `${xTopL},${yTop} ${xTopR},${yTop} ${xTopR},${yTop + bandH} ${xTopL},${yTop + bandH}`
                  : `${xTopL},${yTop} ${xTopR},${yTop} ${xBotR},${yTop + bandH} ${xBotL},${yTop + bandH}`;

                return (
                  <g key={r.key}>
                    <text x={0} y={yMid} textAnchor="start" dominantBaseline="middle"
                          fontSize={TYPE.caption} fontWeight="600" fill="#334155"
                          style={{ fontFamily: FONT_BODY }}>
                      {r.label}
                    </text>
                    <polygon points={pts} fill={`url(#fnl-${r.key})`} />
                    <text x={W} y={yMid} textAnchor="end" dominantBaseline="middle"
                          fontSize={TYPE.body} fontWeight="800" fill="#0f172a"
                          style={{ fontFamily: FONT_BODY, fontVariantNumeric: "tabular-nums" }}>
                      {r.value}
                    </text>
                  </g>
                );
              })}
            </svg>
          </Box>

          {/* Stage-by-stage conversion readout */}
          <Box display="flex" flexDirection="column" gap={0.75}>
            {rows.map((r, i) => (
              <Box key={r.key} display="flex" alignItems="center" gap={1}
                   sx={{ px: 1.5, py: 0.75, minHeight: 32, borderRadius: `${RADIUS.sm}px`, bgcolor: `${r.color}0d` }}>
                <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: r.color, flexShrink: 0 }} />
                <Typography sx={{ fontFamily: FONT_BODY, fontSize: TYPE.small, fontWeight: 600, color: "#334155", flex: 1 }} noWrap>
                  {r.label}
                </Typography>
                <Typography sx={{ ...NUM, fontSize: TYPE.small, fontWeight: 800, color: "#0f172a", minWidth: 36, textAlign: "right" }}>
                  {r.value}
                </Typography>
                <Typography sx={{ ...NUM, fontSize: TYPE.caption, color: "#94a3b8", minWidth: 56, textAlign: "right", whiteSpace: "nowrap" }}>
                  {r.pctOfTop.toFixed(0)}% total
                </Typography>
                {i > 0 ? (
                  <Tooltip title={`${r.dropFromPrev} dropped off after ${rows[i - 1].label}`} arrow placement="left">
                    <Box sx={{
                      display: "inline-flex", alignItems: "center", gap: 0.5, height: 24,
                      px: 1, borderRadius: `${RADIUS.sm}px`, minWidth: 56, justifyContent: "center",
                      bgcolor: r.pctOfPrev >= 60 ? "#f0fdf4" : r.pctOfPrev >= 30 ? "#fefce8" : "#fef2f2",
                      color:   r.pctOfPrev >= 60 ? "#15803d" : r.pctOfPrev >= 30 ? "#a16207" : "#dc2626",
                    }}>
                      {r.pctOfPrev >= 60
                        ? <TrendingUp sx={{ fontSize: 12 }} />
                        : <TrendingDown sx={{ fontSize: 12 }} />}
                      <Typography sx={{ ...NUM, fontSize: TYPE.caption, fontWeight: 800 }}>{r.pctOfPrev.toFixed(0)}%</Typography>
                    </Box>
                  </Tooltip>
                ) : (
                  <Box sx={{ minWidth: 56 }} />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </CardContent>
    </SectionCard>
  );
}


// ─── RECRUITER RADAR ──────────────────────────────────────────────────────────
function RecruiterRadarChart({ recruiterBreakdown }) {
  const real = recruiterBreakdown.filter(isRealRecruiter);
  if (real.length < 2) return null;
  const maxVals = {
    total:    Math.max(...real.map((r)=>r.total),1),
    selected: Math.max(...real.map((r)=>r.selected),1),
    jds:      Math.max(...real.map((r)=>r.total_jds||0),1),
    active:   Math.max(...real.map((r)=>r.in_progress),1),
  };
  const datasets = real.map((r, i) => {
    const selRate = r.total > 0 ? (r.selected/r.total)*100 : 0;
    return {
      label: r.recruiter_name.split(" ")[0],
      data:[
        (r.total/(maxVals.total))*100,
        (r.selected/(maxVals.selected))*100,
        ((r.total_jds||0)/(maxVals.jds))*100,
        selRate,
        (r.in_progress/(maxVals.active))*100,
      ],
      backgroundColor:`${PALETTE[i%PALETTE.length]}22`,
      borderColor:PALETTE[i%PALETTE.length],
      borderWidth:2, pointRadius:4,
      pointBackgroundColor:PALETTE[i%PALETTE.length],
    };
  });
  const options = {
    responsive:true, maintainAspectRatio:false,
    layout:{ padding:16 },
    elements:{ line:{ borderWidth:2.5 }, point:{ radius:5, hoverRadius:7 } },
    plugins:{
      legend:{ position:"bottom", labels:{ boxWidth:12, boxHeight:12, font:chartFont(TYPE.small), padding:16 } },
      datalabels:{ display:false },
      tooltip:{ callbacks:{ label:(ctx)=>`${ctx.dataset.label}: ${ctx.parsed.r.toFixed(0)}` }, backgroundColor:"#0f172a", padding:10 },
    },
    scales:{ r:{ beginAtZero:true, max:100, grid:{ color:"#f1f5f9" }, angleLines:{ color:"#e2e8f0" }, pointLabels:{ font:chartFont(TYPE.small, 600), color:"#334155" }, ticks:{ display:false } } },
  };
  return (
    <SectionCard>
      <CardContent sx={{ p:2.5 }}>
        <SectionHeader icon={<Speed sx={{ fontSize:15, color:"#8b5cf6" }} />} title="Recruiter Performance Shape" subtitle="Normalized across Volume · Selected · JDs · Sel Rate · Active" />
        <Box sx={{ height:{ xs:380, md:520 }, maxWidth:640, mx:"auto" }}>
          <Radar data={{ labels:["Volume","Selected","JDs","Sel Rate","Active"], datasets }} options={options} />
        </Box>
      </CardContent>
    </SectionCard>
  );
}









// ─── RECRUITER RADAR ──────────────────────────────────────────────────────────
function RecruiterRadarChart1({ recruiterBreakdown }) {
  const real = recruiterBreakdown.filter(isRealRecruiter);
  if (real.length < 2) return null;
  const maxVals = {
    total:    Math.max(...real.map((r)=>r.total),1),
    selected: Math.max(...real.map((r)=>r.selected),1),
    jds:      Math.max(...real.map((r)=>r.total_jds||0),1),
    active:   Math.max(...real.map((r)=>r.in_progress),1),
  };
  const datasets = real.map((r, i) => {
    const selRate = r.total > 0 ? (r.selected/r.total)*100 : 0;
    return {
      label: r.recruiter_name.split(" ")[0],
      data:[
        (r.total/(maxVals.total))*100,
        (r.selected/(maxVals.selected))*100,
        ((r.total_jds||0)/(maxVals.jds))*100,
        selRate,
        (r.in_progress/(maxVals.active))*100,
      ],
      backgroundColor:`${PALETTE[i%PALETTE.length]}22`,
      borderColor:PALETTE[i%PALETTE.length],
      borderWidth:2, pointRadius:4,
      pointBackgroundColor:PALETTE[i%PALETTE.length],
    };
  });
  const options = {
    responsive:true, maintainAspectRatio:false,
    plugins:{
      legend:{ position:"bottom", labels:{ boxWidth:10, font:chartFont(TYPE.caption) } },
      datalabels:{ display:false },
      tooltip:{ callbacks:{ label:(ctx)=>`${ctx.dataset.label}: ${ctx.parsed.r.toFixed(0)}` }, backgroundColor:"#0f172a", padding:10 },
    },
    scales:{ r:{ beginAtZero:true, max:100, grid:{ color:"#f1f5f9" }, pointLabels:{ font:chartFont(TYPE.caption) }, ticks:{ display:false } } },
  };
  return (
    <SectionCard>
      <CardContent sx={{ p:2.5 }}>
        <SectionHeader icon={<Speed sx={{ fontSize:15, color:"#8b5cf6" }} />} title="Recruiter Performance Shape" subtitle="Normalized across Volume · Selected · JDs · Sel Rate · Active" />
        <Box sx={{ height:290 }}><Radar data={{ labels:["Volume","Selected","JDs","Sel Rate","Active"], datasets }} options={options} /></Box>
      </CardContent>
    </SectionCard>
  );
}

// ─── TOP PERFORMERS ───────────────────────────────────────────────────────────
function TopPerformersStrip({ recruiterBreakdown }) {
  const real = recruiterBreakdown.filter(isRealRecruiter);
  if (!real.length) return null;
  const bySelected = [...real].sort((a,b)=>b.selected-a.selected);
  const bySelRate  = [...real].sort((a,b)=>(b.total>0?b.selected/b.total:0)-(a.total>0?a.selected/a.total:0));
  const byVolume   = [...real].sort((a,b)=>b.total-a.total);
  const byActive   = [...real].sort((a,b)=>b.in_progress-a.in_progress);
  const cols = [
    { label:"Most Selected",  icon:<EmojiEvents sx={{ fontSize:13, color:"#f59e0b" }}/>, bg:"#fffbeb", color:"#d97706",
      items:bySelected.slice(0,3).map(r=>({ name:r.recruiter_name, val:`${r.selected} selected` })) },
    { label:"Best Sel Rate",  icon:<Star sx={{ fontSize:13, color:"#6366f1" }}/>,        bg:"#eef2ff", color:"#6366f1",
      items:bySelRate.slice(0,3).map(r=>({ name:r.recruiter_name, val:fmtPct(r.selected,r.total) })) },
    { label:"Top Volume",     icon:<TrendingUp sx={{ fontSize:13, color:"#10b981" }}/>,  bg:"#f0fdf4", color:"#059669",
      items:byVolume.slice(0,3).map(r=>({ name:r.recruiter_name, val:`${r.total} total` })) },
    { label:"Most Active",    icon:<Speed sx={{ fontSize:13, color:"#0ea5e9" }}/>,       bg:"#f0f9ff", color:"#0369a1",
      items:byActive.slice(0,3).map(r=>({ name:r.recruiter_name, val:`${r.in_progress} active` })) },
  ];
  return (
    <SectionCard>
      <CardContent sx={{ p:2.5 }}>
        <SectionHeader icon={<EmojiEvents sx={{ fontSize:15, color:"#f59e0b" }} />} title="Top Performers" subtitle="Ranked by key recruitment metrics" />
        <Grid container spacing={1.5}>
          {cols.map((col) => (
            <Grid item xs={6} md={3} key={col.label}>
              <Box sx={{ p:1.5, borderRadius:`${RADIUS.md}px`, bgcolor:col.bg, border:`1px solid ${col.color}22`, height:"100%" }}>
                <Box display="flex" alignItems="center" gap={0.8} mb={1.2}>{col.icon}<Typography fontSize={TYPE.caption} fontWeight={700} color={col.color}>{col.label}</Typography></Box>
                <Box display="flex" flexDirection="column" gap={0.9}>
                  {col.items.map((item, idx) => (
                    <Box key={item.name} display="flex" alignItems="center" gap={0.8}>
                      <Typography fontSize={TYPE.overline} fontWeight={800} color={idx===0?col.color:"#94a3b8"} sx={{ minWidth:14 }}>#{idx+1}</Typography>
                      <Avatar sx={{ width:24, height:24, fontSize:TYPE.overline, fontWeight:800, bgcolor:idx===0?col.color:"#e2e8f0", color:idx===0?"#fff":"#64748b" }}>{nameInitials(item.name)}</Avatar>
                      <Box flex={1} minWidth={0}>
                        <Typography fontSize={TYPE.caption} fontWeight={idx===0?700:500} color="#0f172a" noWrap>{item.name.split(" ")[0]}</Typography>
                        <Typography fontSize={TYPE.overline} color={col.color} fontWeight={600}>{item.val}</Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </SectionCard>
  );
}

// ─── RECRUITER SUMMARY TABLE ──────────────────────────────────────────────────
function RecruiterSummaryTable({ recruiterBreakdown }) {
  const real = [...recruiterBreakdown.filter(isRealRecruiter)].sort((a,b)=>b.total-a.total);
  if (!real.length) return null;
  const maxTotal = real[0]?.total || 1;
  return (
    <SectionCard>
      <CardContent sx={{ p:0 }}>
        <Box p={2.5} pb={1.5}>
          <SectionHeader icon={<People sx={{ fontSize:15, color:"#0ea5e9" }} />} title="All Recruiters — At a Glance" subtitle="Complete pipeline metrics with selection rate indicators" />
        </Box>
        <Box sx={{ overflowX:"auto" }}>
          <Table size="small" sx={{ minWidth:780 }}>
            <TableHead>
              <TableRow sx={{ bgcolor:"#f8fafc" }}>
                {["#","Recruiter","JDs Assigned","JDs w/ Cands","Total","Selected","Rejected","Sel %","Volume"].map((h) => (
                  <TableCell key={h} align={["#","Recruiter"].includes(h)?"left":"center"}
                    sx={HEAD_CELL_SX}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {real.map((r, i) => {
                const color   = PALETTE[i % PALETTE.length];
                const selRate = r.total > 0 ? (r.selected/r.total)*100 : 0;
                const volPct  = (r.total/maxTotal)*100;
                return (
                  <TableRow key={r.recruiter_id} hover>
                    <TableCell sx={{ px:1.2, py:1 }}>
                      <Box sx={{ width:22, height:22, borderRadius:"50%",
                        bgcolor:i===0?"#fef3c7":i===1?"#f1f5f9":i===2?"#fde8c8":"#f8fafc",
                        display:"flex", alignItems:"center", justifyContent:"center" }}>
                        <Typography fontSize={TYPE.overline} fontWeight={800} color={i===0?"#d97706":i===1?"#94a3b8":i===2?"#b45309":"#cbd5e1"}>{i+1}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ px:1.2, py:1 }}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Avatar sx={{ width:28, height:28, fontSize:TYPE.overline, fontWeight:800, bgcolor:color }}>{nameInitials(r.recruiter_name)}</Avatar>
                        <Box>
                          <Typography fontSize={TYPE.caption} fontWeight={600} color="#0f172a" noWrap>{r.recruiter_name}</Typography>
                          <Typography fontSize={TYPE.overline} color="#94a3b8" noWrap>{r.recruiter_email}</Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ px:1.2 }}>
                      <Chip label={r.total_jds_assigned||r.total_jds||0} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#eff6ff", color:"#2563eb", height:24 }} />
                    </TableCell>
                    <TableCell align="center" sx={{ px:1.2 }}>
                      <Chip label={r.total_jds_with_candidates||0} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#f0fdf4", color:"#15803d", height:24 }} />
                    </TableCell>
                    <TableCell align="center" sx={{ px:1.2 }}>
                      <Typography fontWeight={800} fontSize={TYPE.small} color="#0f172a">{r.total}</Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ px:1.2 }}>
                      <Typography fontWeight={700} fontSize={TYPE.caption} color="#15803d">{r.selected}</Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ px:1.2 }}>
                      <Typography fontWeight={700} fontSize={TYPE.caption} color="#dc2626">{r.rejected}</Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ px:1.2 }}>
                      <Box sx={{ display:"inline-flex", alignItems:"center", justifyContent:"center", px:0.9, py:0.2, borderRadius:`${RADIUS.sm}px`,
                        bgcolor:selRate>=30?"#f0fdf4":selRate>=15?"#fefce8":"#fef2f2",
                        color:selRate>=30?"#15803d":selRate>=15?"#a16207":"#dc2626" }}>
                        <Typography fontSize={TYPE.caption} fontWeight={800}>{selRate.toFixed(1)}%</Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ px:1.2, minWidth:90 }}>
                      <LinearProgress variant="determinate" value={volPct}
                        sx={{ height:6, borderRadius:4, bgcolor:`${color}18`, "& .MuiLinearProgress-bar":{ bgcolor:color, borderRadius:4 } }} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </SectionCard>
  );
}

// ─── JD ROW ──────────────────────────────────────────────────────────────────
function JdRow({ jd, periodLabel, recruiterBreakdown }) {
  const [open, setOpen] = useState(false);
  const entries = sortedStatusEntries(jd.status_counts || {});
  const statusRecruiterMap = recruiterBreakdown ? buildStatusRecruiterMap(jd.jdID, recruiterBreakdown) : {};
  return (
    <>
      <TableRow hover sx={{ cursor:"pointer", bgcolor:open?"#f8fafc":"inherit" }} onClick={()=>setOpen(o=>!o)}>
        <TableCell sx={{ pl:3 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width:26, height:26, borderRadius:`${RADIUS.sm}px`, bgcolor:"#eff6ff", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <Work sx={{ color:"#6366f1", fontSize:13 }} />
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={TYPE.caption} color="#0f172a">{jd.jobRole || "—"}</Typography>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Business sx={{ fontSize:TYPE.overline, color:"#94a3b8" }} />
                <Typography fontSize={TYPE.overline} color="#64748b">{jd.companyName}</Typography>
                <Typography fontSize={TYPE.overline} color="#6366f1" fontWeight={700} fontFamily={FONT_MONO}>· {jd.jdID}</Typography>
              </Box>
            </Box>
          </Box>
        </TableCell>
        <TableCell align="center"><Typography fontWeight={700} fontSize={TYPE.small}>{jd.total}</Typography></TableCell>
        <TableCell align="center"><Chip label={jd.ranged_total??0} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#eff6ff", color:"#6366f1" }} /></TableCell>
        <TableCell align="center"><Chip label={`${jd.selected} · ${fmtPctInt(jd.selected,jd.total)}`} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#f0fdf4", color:"#15803d" }} /></TableCell>
        <TableCell align="center"><Chip label={`${jd.rejected} · ${fmtPctInt(jd.rejected,jd.total)}`} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#fef2f2", color:"#dc2626" }} /></TableCell>
        <TableCell align="center"><Chip label={jd.total-jd.selected-jd.rejected} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#fff7ed", color:"#c2410c" }} /></TableCell>
        <TableCell align="right" sx={{ pr:2 }}>
          <IconButton size="small">{open?<KeyboardArrowUp fontSize="small"/>:<KeyboardArrowDown fontSize="small"/>}</IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={7} sx={{ p:0, border:0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ px:3, py:2, bgcolor:"#f8fafc", borderBottom:"1px solid #f1f5f9" }}>
              <Typography fontSize={TYPE.overline} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>Status breakdown — {jd.jobRole || jd.jdID}</Typography>
              {recruiterBreakdown?.filter(isRealRecruiter).length > 1 && (
                <Box display="flex" flexWrap="wrap" gap={0.8} mb={1.5}>
                  {recruiterBreakdown.filter(isRealRecruiter).map((r, ri) => {
                    const contributed = (r.jd_breakdown||[]).some((j)=>j.jdID===jd.jdID&&j.total>0);
                    if (!contributed) return null;
                    return (
                      <Box key={r.recruiter_id} display="flex" alignItems="center" gap={0.5}>
                        <Box sx={{ width:8, height:8, borderRadius:"50%", bgcolor:PALETTE[ri%PALETTE.length] }} />
                        <Typography fontSize={TYPE.overline} color="#64748b">{r.recruiter_name}</Typography>
                      </Box>
                    );
                  })}
                </Box>
              )}
              <Box display="flex" flexDirection="column" gap={0.8}>
                {entries.map(([status, count]) => (
                  <StatusRowWithRecruiters key={status} status={status} count={count} recruiterCounts={statusRecruiterMap[status]||[]} />
                ))}
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

// ─── JD OVERALL SECTION WITH TABS ────────────────────────────────────────────
function JdOverallSection({ jdOverall, recruiterBreakdown, periodLabel }) {
  const [expandedJd, setExpandedJd] = useState(null);
  const [expandedRecruiterJd, setExpandedRecruiterJd] = useState(null);
  const [sectionOpen, setSectionOpen] = useState(false);
  if (!jdOverall.length) return null;
  const realRecruiters = recruiterBreakdown.filter(isRealRecruiter);

  return (
    <SectionCard>
      <CardContent sx={{ p:2.5, pb:sectionOpen?2.5:"20px !important" }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}
          sx={{ cursor:"pointer", userSelect:"none" }} onClick={()=>setSectionOpen(o=>!o)}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box sx={{ width:32, height:32, borderRadius:`${RADIUS.sm}px`, bgcolor:sectionOpen?"#eff6ff":"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", transition:"background 0.2s" }}>
              <Work sx={{ fontSize:15, color:sectionOpen?"#6366f1":"#64748b" }} />
            </Box>
            <Box>
              <Typography fontWeight={700} fontSize={TYPE.cardTitle} color="#0f172a">JD-wise Candidate Breakdown</Typography>
              <Typography fontSize={TYPE.caption} color="#94a3b8" mt={0.2}>All JDs across all recruiters · expand for status and recruiter splits</Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Chip label={`${jdOverall.length} JDs`} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#eff6ff", color:"#6366f1" }} />
            <Chip label={sectionOpen?"Collapse":"Expand"} size="small" sx={{ ...MINI_CHIP_SX, cursor:"pointer", bgcolor:sectionOpen?"#f1f5f9":"#0f172a", color:sectionOpen?"#475569":"#fff" }} />
          </Box>
        </Box>
        <Collapse in={sectionOpen} timeout="auto" unmountOnExit>
          <Box mt={2}>
            <Paper variant="outlined" sx={{ borderRadius:`${RADIUS.md}px`, overflow:"hidden", border:"1px solid #f1f5f9" }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor:"#f8fafc" }}>
                    {["","JD / Role","Company","Recruiters","Candidates","In Period","Selected","Rejected","Sel Rate"].map((h) => (
                      <TableCell key={h} align={["","JD / Role","Company"].includes(h)?"left":"center"}
                        sx={HEAD_CELL_SX}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {jdOverall.map((jd) => {
                    const isOpen = expandedJd === jd.jdID;
                    const entries = sortedStatusEntries(jd.status_counts || {});
                    const perRecruiter = realRecruiters.map((r,ri) => {
                      const jdEntry = (r.jd_breakdown||[]).find(j=>j.jdID===jd.jdID);
                      return jdEntry ? { name:r.recruiter_name, color:PALETTE[ri%PALETTE.length], total:jdEntry.total, ranged:jdEntry.ranged_total??0, selected:jdEntry.selected, rejected:jdEntry.rejected } : null;
                    }).filter(Boolean).sort((a,b)=>b.total-a.total);
                    const statusRecruiterMap = buildStatusRecruiterMap(jd.jdID, realRecruiters);
                    return (
                      <React.Fragment key={jd.jdID}>
                        <TableRow hover sx={{ cursor:"pointer", bgcolor:isOpen?"#f0f9ff":"inherit" }} onClick={()=>setExpandedJd(isOpen?null:jd.jdID)}>
                          <TableCell sx={{ width:36, pl:1.5 }}>
                            <IconButton size="small" sx={{ p:0.5 }}>
                              {isOpen?<KeyboardArrowUp fontSize="small"/>:<KeyboardArrowDown fontSize="small"/>}
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <Typography fontWeight={600} fontSize={TYPE.caption} color="#0f172a">{jd.jobRole||"—"}</Typography>
                            <Typography fontSize={TYPE.overline} color="#6366f1" fontWeight={700} fontFamily={FONT_MONO}>{jd.jdID}</Typography>
                          </TableCell>
                          <TableCell><Typography fontSize={TYPE.caption} color="#64748b">{jd.companyName||"—"}</Typography></TableCell>
                          <TableCell>
                            <Box display="flex" flexWrap="wrap" gap={0.5}>
                              {perRecruiter.length===0 ? <Typography fontSize={TYPE.overline} color="#94a3b8">—</Typography>
                                : perRecruiter.map((r)=>(
                                  <Tooltip key={r.name} title={`${r.name} · ${r.total} total · ${r.ranged} in period`}>
                                    <Typography sx={{ fontSize:TYPE.overline, fontWeight:800, color:r.color, bgcolor:`${r.color}15`, px:1, py:0.25, borderRadius:1, display:"inline-flex", alignItems:"center" }}>{r.name}</Typography>
                                  </Tooltip>
                                ))}
                            </Box>
                          </TableCell>
                          <TableCell align="center"><Typography fontWeight={800} fontSize={TYPE.body} color="#0f172a">{jd.total}</Typography></TableCell>
                          <TableCell align="center"><Chip label={jd.ranged_total??0} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#eff6ff", color:"#6366f1" }} /></TableCell>
                          <TableCell align="center"><Chip label={jd.selected} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#f0fdf4", color:"#15803d" }} /></TableCell>
                          <TableCell align="center"><Chip label={jd.rejected} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#fef2f2", color:"#dc2626" }} /></TableCell>
                          <TableCell align="center">
                            <Typography fontWeight={800} fontSize={TYPE.caption} color={jd.selected>0?"#15803d":"#94a3b8"}>{fmtPctInt(jd.selected,jd.total)}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={9} sx={{ p:0, border:0 }}>
                            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                              <Box sx={{ bgcolor:"#f8fafc", borderBottom:"1px solid #e2e8f0" }}>
                                <Box p={2.5}>
                                  <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
                                    <Typography fontSize={TYPE.overline} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em">Status breakdown — {jd.jobRole||jd.jdID}</Typography>
                                    {perRecruiter.length>1 && (
                                      <Box display="flex" flexWrap="wrap" gap={0.8}>
                                        {perRecruiter.map((r)=>(
                                          <Box key={r.name} display="flex" alignItems="center" gap={0.5}>
                                            <Box sx={{ width:8, height:8, borderRadius:"50%", bgcolor:r.color }} />
                                            <Typography fontSize={TYPE.overline} color="#64748b">{r.name}</Typography>
                                          </Box>
                                        ))}
                                      </Box>
                                    )}
                                  </Box>
                                  <Box display="flex" flexDirection="column" gap={0.8}>
                                    {entries.map(([status, count]) => (
                                      <StatusRowWithRecruiters key={status} status={status} count={count} recruiterCounts={statusRecruiterMap[status]||[]} />
                                    ))}
                                  </Box>
                                </Box>
                                <Box sx={{ borderTop:"1px solid #f1f5f9" }}>
                                  <Box display="flex" alignItems="center" justifyContent="space-between" px={2.5} py={1.2}
                                    sx={{ cursor:"pointer","&:hover":{ bgcolor:"#f1f5f9" } }}
                                    onClick={(e)=>{ e.stopPropagation(); setExpandedRecruiterJd(prev=>prev===jd.jdID?null:jd.jdID); }}>
                                    <Box display="flex" alignItems="center" gap={1}>
                                      <Groups sx={{ fontSize:15, color:"#64748b" }} />
                                      <Typography fontSize={TYPE.caption} fontWeight={600} color="#374151">Recruiter breakdown</Typography>
                                      <Chip label={`${perRecruiter.length} recruiter${perRecruiter.length!==1?"s":""}`} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#eff6ff", color:"#6366f1", height:24 }} />
                                    </Box>
                                    <IconButton size="small" sx={{ p:0.5 }}>
                                      {expandedRecruiterJd===jd.jdID?<KeyboardArrowUp fontSize="small"/>:<KeyboardArrowDown fontSize="small"/>}
                                    </IconButton>
                                  </Box>
                                  <Collapse in={expandedRecruiterJd===jd.jdID} timeout="auto" unmountOnExit>
                                    <Box px={2.5} pb={2.5}>
                                      {perRecruiter.length===0
                                        ? <Box display="flex" alignItems="center" justifyContent="center" sx={{ height:60, bgcolor:"#f1f5f9", borderRadius:`${RADIUS.sm}px` }}><Typography fontSize={TYPE.caption} color="#94a3b8">No recruiters assigned</Typography></Box>
                                        : <Paper variant="outlined" sx={{ borderRadius:`${RADIUS.sm}px`, overflow:"hidden", border:"1px solid #e2e8f0" }}>
                                            <Table size="small">
                                              <TableHead>
                                                <TableRow sx={{ bgcolor:"#f8fafc" }}>
                                                  {["Recruiter","Candidates","In Period","Selected","Rejected","Sel Rate"].map(h=>(
                                                    <TableCell key={h} sx={{ ...HEAD_CELL_SX, py:1, px:1.2 }}>{h}</TableCell>
                                                  ))}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {perRecruiter.map(r=>(
                                                  <TableRow key={r.name} hover>
                                                    <TableCell sx={{ py:0.8, px:1.2 }}>
                                                      <Box display="flex" alignItems="center" gap={0.8}>
                                                        <Avatar sx={{ width:22, height:22, fontSize:TYPE.overline, fontWeight:800, bgcolor:r.color }}>{nameInitials(r.name)}</Avatar>
                                                        <Typography fontSize={TYPE.caption} fontWeight={600} noWrap>{r.name}</Typography>
                                                      </Box>
                                                    </TableCell>
                                                    <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontWeight={700} fontSize={TYPE.caption}>{r.total}</Typography></TableCell>
                                                    <TableCell sx={{ py:0.8, px:1.2 }}><Chip label={r.ranged} size="small" sx={{ ...MINI_CHIP_SX, bgcolor:"#eff6ff", color:"#6366f1", height:24 }} /></TableCell>
                                                    <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontSize={TYPE.caption} color="#15803d" fontWeight={700}>{r.selected}</Typography></TableCell>
                                                    <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontSize={TYPE.caption} color="#dc2626" fontWeight={700}>{r.rejected}</Typography></TableCell>
                                                    <TableCell sx={{ py:0.8, px:1.2 }}><Typography fontSize={TYPE.caption} color="#6366f1" fontWeight={700}>{fmtPct(r.selected,r.total)}</Typography></TableCell>
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          </Paper>
                                      }
                                    </Box>
                                  </Collapse>
                                </Box>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          </Box>
        </Collapse>
      </CardContent>
    </SectionCard>
  );
}

// ─── RECRUITER TIMELINE CHART ─────────────────────────────────────────────────
function RecruiterTimelineChart({ recruiterBreakdown, timelineLabels, periodLabel }) {
  const [chartType, setChartType]     = useState("line");
  const [cumulative, setCumulative]   = useState(false);
  const [hiddenLines, setHiddenLines] = useState({});
  const realRecruiters = recruiterBreakdown.filter(isRealRecruiter);
  if (!timelineLabels.length || !realRecruiters.length) return null;
  if (!realRecruiters.filter(r=>(r.timeline||[]).some(v=>v>0)).length) return null;

  const formattedLabels = timelineLabels.map(d=>new Date(d).toLocaleDateString("en-IN",{ day:"numeric", month:"short" }));
  const toCumulative = (arr) => arr.reduce((acc,v,i)=>{ acc.push((acc[i-1]||0)+v); return acc; },[]);

  const datasets = realRecruiters.map((r,i) => {
    const color = PALETTE[i%PALETTE.length];
    const raw   = r.timeline || timelineLabels.map(()=>0);
    const data  = cumulative ? toCumulative(raw) : raw;
    return {
      label:r.recruiter_name, data, hidden:!!hiddenLines[r.recruiter_id],
      borderColor:color, backgroundColor:chartType==="bar"?`${color}bb`:`${color}18`,
      fill:chartType==="line", tension:0.4,
      pointRadius:timelineLabels.length>30?2:4, pointHoverRadius:6,
      pointBackgroundColor:color, pointBorderColor:"#fff", pointBorderWidth:1.5,
      borderWidth:chartType==="bar"?1:2, borderRadius:chartType==="bar"?3:0,
    };
  });

  const commonOptions = {
    responsive:true, maintainAspectRatio:false,
    interaction:{ mode:"index", intersect:false },
    plugins:{
      legend:{ display:false },
      tooltip:{ callbacks:{ title:items=>items[0]?.label||"", label:ctx=>` ${ctx.dataset.label}: ${ctx.parsed.y} candidate${ctx.parsed.y!==1?"s":""}` },
        backgroundColor:"#0f172a", titleColor:"#94a3b8", bodyColor:"#f1f5f9", padding:10, cornerRadius:8 },
      datalabels:{ display:false },
    },
    scales:{
      x:{ grid:{ display:false }, ticks:{ font:chartFont(TYPE.overline), maxRotation:45, autoSkip:true, maxTicksLimit:14 }, stacked:chartType==="bar" },
      y:{ beginAtZero:true, grid:{ color:"#f8fafc" }, ticks:{ font:chartFont(TYPE.overline), stepSize:1, callback:v=>Number.isInteger(v)?v:"" },
        stacked:chartType==="bar", title:{ display:true, text:cumulative?"Cumulative candidates":"Candidates added", font:chartFont(TYPE.overline), color:"#94a3b8" } },
    },
  };

  const recruiterTotals = realRecruiters.map(r=>({ ...r, periodTotal:(r.timeline||[]).reduce((s,v)=>s+v,0) })).sort((a,b)=>b.periodTotal-a.periodTotal);
  const maxPeriodTotal = Math.max(...recruiterTotals.map(r=>r.periodTotal),1);
  const toggleLine = (rid) => setHiddenLines(prev=>({...prev,[rid]:!prev[rid]}));

  return (
    <SectionCard>
      <CardContent sx={{ p:2.5 }}>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={1.5} mb={2}>
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={0.3}>
              <Box sx={{ width:32, height:32, borderRadius:`${RADIUS.sm}px`, bgcolor:"#f0f9ff", display:"flex", alignItems:"center", justifyContent:"center" }}>
                <Timeline sx={{ fontSize:15, color:"#0ea5e9" }} />
              </Box>
              <Typography fontWeight={700} fontSize={TYPE.cardTitle} color="#0f172a">Recruiter Intake Timeline</Typography>
            </Box>
            <Typography fontSize={TYPE.caption} color="#94a3b8" ml={5}>Candidates added per day · {periodLabel} · click legend to toggle</Typography>
          </Box>
          <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
            <Box display="flex" sx={{ border:"1px solid #e2e8f0", borderRadius:`${RADIUS.sm}px`, overflow:"hidden" }}>
              {[{key:"line",label:"Line"},{key:"bar",label:"Stacked"}].map(({key,label})=>(
                <Button key={key} size="small" onClick={()=>setChartType(key)}
                  sx={{ fontSize:TYPE.caption, fontWeight:600, textTransform:"none", px:1.5, py:0.5, borderRadius:0, minWidth:0,
                    bgcolor:chartType===key?"#0f172a":"transparent", color:chartType===key?"#fff":"#64748b",
                    "&:hover":{ bgcolor:chartType===key?"#0f172a":"#f8fafc" } }}>{label}</Button>
              ))}
            </Box>
            <Button size="small" onClick={()=>setCumulative(c=>!c)}
              sx={{ fontSize:TYPE.caption, fontWeight:600, textTransform:"none", px:1.5, py:0.5, borderRadius:`${RADIUS.sm}px`, border:"1px solid #e2e8f0",
                bgcolor:cumulative?"#eff6ff":"transparent", color:cumulative?"#6366f1":"#64748b", "&:hover":{ bgcolor:"#f8fafc" } }}>
              {cumulative?"Cumulative ✓":"Cumulative"}
            </Button>
          </Box>
        </Box>
        <Grid container spacing={2.5}>
          <Grid item xs={12} md={9}>
            <Box sx={{ height:290 }}>
              {chartType==="line"?<Line data={{ labels:formattedLabels, datasets }} options={commonOptions}/>:<Bar data={{ labels:formattedLabels, datasets }} options={commonOptions}/>}
            </Box>
            <Box display="flex" flexWrap="wrap" gap={1} mt={1.5}>
              {realRecruiters.map((r,i) => {
                const color = PALETTE[i%PALETTE.length];
                const hidden = !!hiddenLines[r.recruiter_id];
                return (
                  <Box key={r.recruiter_id} display="flex" alignItems="center" gap={0.6} onClick={()=>toggleLine(r.recruiter_id)}
                    sx={{ px:1.2, py:0.5, borderRadius:`${RADIUS.sm}px`, cursor:"pointer", border:`1px solid ${hidden?"#e2e8f0":color+"40"}`,
                      bgcolor:hidden?"#f8fafc":`${color}0d`, opacity:hidden?0.45:1, transition:"all 0.15s","&:hover":{ opacity:1 } }}>
                    <Box sx={{ width:10, height:10, borderRadius:"50%", bgcolor:hidden?"#cbd5e1":color }} />
                    <Typography fontSize={TYPE.caption} fontWeight={600} color={hidden?"#94a3b8":"#374151"} noWrap>{r.recruiter_name}</Typography>
                  </Box>
                );
              })}
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ bgcolor:"#f8fafc", borderRadius:`${RADIUS.md}px`, border:"1px solid #f1f5f9", p:1.5, height:"100%" }}>
              <Typography fontSize={TYPE.overline} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>In Period · Leaderboard</Typography>
              <Box display="flex" flexDirection="column" gap={1.2}>
                {recruiterTotals.map((r,rank) => {
                  const color = PALETTE[realRecruiters.findIndex(rb=>rb.recruiter_id===r.recruiter_id)%PALETTE.length];
                  const hidden = !!hiddenLines[r.recruiter_id];
                  return (
                    <Box key={r.recruiter_id} onClick={()=>toggleLine(r.recruiter_id)} sx={{ cursor:"pointer", opacity:hidden?0.4:1, transition:"opacity 0.15s" }}>
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.4}>
                        <Box display="flex" alignItems="center" gap={0.8}>
                          <Typography fontSize={TYPE.overline} fontWeight={800} sx={{ width:16, color:rank===0?"#d97706":rank===1?"#64748b":"#94a3b8" }}>#{rank+1}</Typography>
                          <Avatar sx={{ width:24, height:24, fontSize:TYPE.overline, fontWeight:800, bgcolor:color }}>{nameInitials(r.recruiter_name)}</Avatar>
                          <Typography fontSize={TYPE.caption} fontWeight={600} color="#374151" noWrap sx={{ maxWidth:90 }}>{r.recruiter_name.split(" ")[0]}</Typography>
                        </Box>
                        <Typography fontSize={TYPE.caption} fontWeight={800} color={color}>{r.periodTotal}</Typography>
                      </Box>
                      <LinearProgress variant="determinate" value={(r.periodTotal/maxPeriodTotal)*100}
                        sx={{ height:4, borderRadius:4, bgcolor:`${color}18`, "& .MuiLinearProgress-bar":{ bgcolor:color, borderRadius:4 } }} />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </SectionCard>
  );
}

// ─── PER-RECRUITER CARD WITH JD TABS (Active / Empty) ────────────────────────
function RecruiterCard({ recruiter, color, timelineLabels, periodLabel, allRecruiterBreakdown }) {
  const { recruiter_name, recruiter_email, total, total_jds, total_jds_assigned, selected, rejected, in_progress,
          status_counts, jd_breakdown, timeline } = recruiter;
  const [jdTab, setJdTab] = useState(0);
  const entries  = sortedStatusEntries(status_counts || {});
  const selPct   = fmtPct(selected, total);
  const rejPct   = fmtPct(rejected, total);
  const selRate  = total > 0 ? (selected/total)*100 : 0;

  const activeJDs  = (jd_breakdown||[]).filter(jd=>jd.has_candidates!==false && jd.total>0);
  const emptyJDs   = (jd_breakdown||[]).filter(jd=>jd.has_candidates===false || jd.total===0);
  const displayJDs = jdTab===0 ? activeJDs : emptyJDs;

  const chartData = {
    labels: timelineLabels.map(d=>new Date(d).toLocaleDateString("en-IN",{ day:"numeric", month:"short" })),
    datasets:[{
      label:"Candidates added", data:timeline||[], borderColor:color, backgroundColor:`${color}18`,
      fill:true, tension:0.4, pointRadius:3, pointBackgroundColor:color, pointBorderColor:"#fff", pointBorderWidth:1.5,
    }],
  };
  const chartOptions = {
    responsive:true, maintainAspectRatio:false,
    plugins:{ legend:{ display:false }, tooltip:{ callbacks:{ label:ctx=>` ${ctx.parsed.y} candidates added` } }, datalabels:{ display:false } },
    scales:{
      x:{ grid:{ display:false }, ticks:{ font:chartFont(TYPE.overline), maxRotation:45, autoSkip:true, maxTicksLimit:10 } },
      y:{ beginAtZero:true, grid:{ color:"#f8fafc" }, ticks:{ font:chartFont(TYPE.overline), stepSize:1, callback:v=>Number.isInteger(v)?v:"" } },
    },
  };

  return (
    <Accordion elevation={0} sx={{ mb:2, borderRadius:"16px !important", border:"1px solid #e2e8f0", "&:before":{ display:"none" }, "&.Mui-expanded":{ margin:"0 0 16px 0" } }}>
      <AccordionSummary expandIcon={<ExpandMore />} sx={{ px:2.5, py:1.5, borderRadius:"16px", "&.Mui-expanded":{ borderRadius:"16px 16px 0 0", borderBottom:"1px solid #f1f5f9" } }}>
        <Box display="flex" alignItems="center" gap={2} flex={1} flexWrap="wrap" pr={1}>
          <Box sx={{ position:"relative" }}>
            <Avatar sx={{ width:44, height:44, fontWeight:800, fontSize:14, bgcolor:color }}>{nameInitials(recruiter_name)}</Avatar>
            {total === Math.max(...(allRecruiterBreakdown || []).map(r => r.total)) && total > 0 && (
              <Box sx={{ position:"absolute", top:-4, right:-4, width:16, height:16, borderRadius:"50%", bgcolor:"#f59e0b", display:"flex", alignItems:"center", justifyContent:"center" }}>
                <Star sx={{ fontSize:TYPE.overline, color:"#fff" }} />
              </Box>
            )}
          </Box>
          <Box flex={1} minWidth={130}>
            <Typography fontWeight={700} fontSize={TYPE.body} color="#0f172a">{recruiter_name}</Typography>
            <Typography fontSize={TYPE.caption} color="#94a3b8">{recruiter_email}</Typography>
          </Box>
          <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
            <StatPill label="Candidates" val={total}                      color={color}   bg={`${color}10`} />
            <StatPill label="JDs"        val={total_jds_assigned||0}      color="#0369a1" bg="#eff6ff"      />
            <StatPill label="Selected"   val={`${selected} (${selPct})`}  color="#15803d" bg="#f0fdf4"      />
            <StatPill label="Rejected"   val={`${rejected} (${rejPct})`}  color="#dc2626" bg="#fef2f2"      />
            <StatPill label="Active"     val={in_progress}                color="#c2410c" bg="#fff7ed"      />
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ p:0 }}>
        <Grid container>
          {/* Pipeline Status */}
          <Grid item xs={12} md={4} sx={{ borderRight:{ md:"1px solid #f1f5f9" }, borderBottom:{ xs:"1px solid #f1f5f9", md:"none" } }}>
            <Box p={2.5}>
              <Typography fontSize={TYPE.overline} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>Pipeline · All Time</Typography>
              <Box display="flex" flexDirection="column" gap={0.8}>
                {entries.map(([status, count]) => <StatusRow key={status} status={status} count={count} />)}
              </Box>
              <Divider sx={{ my:2 }} />
              <Box display="flex" gap={1} justifyContent="space-between">
                {[
                  { label:"Sel Rate", val:selPct,           color:"#15803d", bg:"#f0fdf4" },
                  { label:"Rej Rate", val:rejPct,           color:"#dc2626", bg:"#fef2f2" },
                  { label:"Active",   val:`${in_progress}`, color:"#c2410c", bg:"#fff7ed" },
                ].map(s=>(
                  <Box key={s.label} flex={1} textAlign="center" sx={{ p:1, borderRadius:`${RADIUS.sm}px`, bgcolor:s.bg }}>
                    <Typography fontWeight={800} fontSize={TYPE.body} color={s.color}>{s.val}</Typography>
                    <Typography fontSize={TYPE.overline} color={s.color} fontWeight={600}>{s.label}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>

          {/* Timeline chart */}
          <Grid item xs={12} md={8}>
            <Box p={2.5}>
              <Typography fontSize={TYPE.overline} fontWeight={700} color="#94a3b8" textTransform="uppercase" letterSpacing="0.06em" mb={1.5}>Candidate Intake · {periodLabel}</Typography>
              {timelineLabels.length > 0 && (timeline||[]).some(v=>v>0) ? (
                <Box sx={{ height:190 }}><Line data={chartData} options={chartOptions} /></Box>
              ) : (
                <Box display="flex" alignItems="center" justifyContent="center" sx={{ height:190, bgcolor:"#f8fafc", borderRadius:`${RADIUS.md}px` }}>
                  <Typography fontSize={TYPE.caption} color="#94a3b8">No intake in this period</Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>

        {/* JD Drill-Down with Active / Empty tabs */}
        <Box sx={{ borderTop:"1px solid #f1f5f9" }}>
          <Box px={2.5} pt={2} pb={0} display="flex" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography fontSize={TYPE.caption} fontWeight={700} color="#0f172a">JD Breakdown — click to expand status</Typography>
              <Typography fontSize={TYPE.overline} color="#94a3b8" mt={0.2}>"In Period" reflects selected window</Typography>
            </Box>
            <Box display="flex" gap={1}>
              <Chip
                icon={<AssignmentTurnedIn sx={{ fontSize:12 }} />}
                label={`Active (${activeJDs.length})`} size="small"
                onClick={()=>setJdTab(0)}
                sx={{ fontWeight:700, cursor:"pointer",
                  bgcolor:jdTab===0?"#10b981":"#f1f5f9",
                  color:jdTab===0?"#fff":"#64748b", fontSize:TYPE.overline, height:22,
                  "& .MuiChip-icon":{ color:jdTab===0?"#fff":"#64748b" } }} />
              <Chip
                icon={<WorkOff sx={{ fontSize:12 }} />}
                label={`Empty JDs (${emptyJDs.length})`} size="small"
                onClick={()=>setJdTab(1)}
                sx={{ fontWeight:700, cursor:"pointer",
                  bgcolor:jdTab===1?"#94a3b8":"#f1f5f9",
                  color:jdTab===1?"#fff":"#64748b", fontSize:TYPE.overline, height:22,
                  "& .MuiChip-icon":{ color:jdTab===1?"#fff":"#64748b" } }} />
            </Box>
          </Box>

          {jdTab === 1 && emptyJDs.length > 0 && (
            <Box px={2.5} py={1.5}>
              <Alert severity="info" sx={{ borderRadius:`${RADIUS.sm}px`, fontSize:TYPE.caption, py:0.5 }}>
                These JDs are assigned to {recruiter_name.split(" ")[0]} but have no candidates added yet.
              </Alert>
              <Box display="flex" flexWrap="wrap" gap={1} mt={1.5}>
                {emptyJDs.map(jd=>(
                  <Box key={jd.jdID} sx={{ px:1.5, py:1, borderRadius:`${RADIUS.sm}px`, border:"1px solid #e2e8f0", bgcolor:"#f8fafc" }}>
                    <Typography fontSize={TYPE.caption} fontWeight={600} color="#0f172a">{jd.jobRole||"—"}</Typography>
                    <Typography fontSize={TYPE.overline} color="#6366f1" fontFamily={FONT_MONO}>{jd.jdID}</Typography>
                    {jd.companyName && <Typography fontSize={TYPE.overline} color="#94a3b8">{jd.companyName}</Typography>}
                  </Box>
                ))}
              </Box>
            </Box>
          )}

          {jdTab === 0 && (
            <Paper variant="outlined" sx={{ mx:0, borderRadius:0, border:"none", borderTop:"1px solid #f1f5f9", overflow:"auto" }}>
              <Table size="small" sx={{ minWidth:640 }}>
                <TableHead>
                  <TableRow sx={{ bgcolor:"#f8fafc" }}>
                    {["JD / Role","Candidates","In Period","Selected","Rejected","Active",""].map(h=>(
                      <TableCell key={h} align={h==="JD / Role"?"left":"center"}
                        sx={{ ...HEAD_CELL_SX, py:1.25, pl:h==="JD / Role"?3:1 }}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayJDs.length===0
                    ? <TableRow><TableCell colSpan={7}><Box display="flex" justifyContent="center" py={3}><Typography fontSize={TYPE.caption} color="#94a3b8">No active JDs</Typography></Box></TableCell></TableRow>
                    : displayJDs.map(jd=>(
                        <JdRow key={jd.jdID} jd={jd} periodLabel={periodLabel} recruiterBreakdown={allRecruiterBreakdown} />
                      ))
                  }
                </TableBody>
              </Table>
            </Paper>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function RbotManagerDashboard() {
  const [data,       setData]       = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState("");
  const [period,     setPeriod]     = useState("month");
  const [dateFrom,   setDateFrom]   = useState("");
  const [dateTo,     setDateTo]     = useState("");
  const [showCustom, setShowCustom] = useState(false);

  // Only the latest request may write state (fast period clicks).
  const loadSeq = useRef(0);

  const load = useCallback(async (p=period, df=dateFrom, dt=dateTo) => {
    const seq = ++loadSeq.current;
    setLoading(true); setError("");
    try {
      let url = `${BASE}/rbot-dashboard/manager?period=${p}`;
      if (p==="custom"&&df) url += `&date_from=${df}&date_to=${dt||todayLocal()}`;
      const res  = await fetch(url,{ headers:getHeaders() });
      let json = {};
      try { json = await res.json(); } catch { /* non-JSON error page */ }
      if (!json?.success) throw new Error(json?.message || `Could not load team analytics (${res.status}).`);
      if (seq === loadSeq.current) setData(json);
    } catch(e) {
      if (seq === loadSeq.current) setError(e.message || "Could not load team analytics.");
    } finally {
      if (seq === loadSeq.current) setLoading(false);
    }
  }, [period, dateFrom, dateTo]);

  useEffect(()=>{ load(); },[]); // eslint-disable-line
  const customRangeInvalid = !dateFrom || (dateTo && dateTo < dateFrom);

  const handlePeriod = (p) => {
    setPeriod(p); setShowCustom(p==="custom");
    if (p!=="custom") load(p,"","");
  };

  const kpis             = data?.kpis               || {};
  const teamStatusCounts = data?.team_status_counts || {};
  const timelineLabels   = data?.timeline_labels    || [];
  const jdOverall        = data?.jd_overall         || [];
  const periodLabel      = PERIODS.find(p=>p.key===period)?.label ?? "";

  // ── Filter "Other" here so every child + KPI uses the clean list ──
  const recruiterBreakdown = (data?.recruiter_breakdown||[]).filter(isRealRecruiter);

  // Standalone route (/rbot-team-analytics) pads itself; when embedded in a dashboard
  // tab the parent container already provides PAGE_PADDING, so add none here.
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const standalone = pathname === "/rbot-team-analytics";

  // Direct visits to the standalone route need a logged-in user.
  useEffect(() => {
    if (!standalone) return;
    const token = localStorage.getItem("token");
    if ((!token || token === "null") && !localStorage.getItem("rbotUser")) navigate("/login", { replace: true });
  }, [standalone, navigate]);
  const rootSx = {
    fontFamily: FONT_BODY,
    p: standalone ? `${PAGE_PADDING}px` : 0,
    "& .MuiTypography-root, & .MuiChip-label, & .MuiTableCell-root": { fontVariantNumeric: "tabular-nums" },
  };

  const heroChipSx = {
    height: 24, borderRadius: `${RADIUS.sm}px`, bgcolor: "rgba(99,102,241,0.18)", color: "#e0e7ff",
    fontFamily: FONT_BODY, fontWeight: 600, border: "1px solid rgba(99,102,241,0.35)",
    "& .MuiChip-label": { fontSize: TYPE.caption, px: 1 }, "& .MuiChip-icon": { ml: 1, mr: -0.25 },
  };
  const heroDateSx = {
    width: 160,
    "& .MuiInputBase-root": { height: CONTROL_HEIGHT.lg, bgcolor: "rgba(255,255,255,0.08)", color: "#fff", fontFamily: FONT_BODY, fontSize: TYPE.small, borderRadius: `${RADIUS.sm}px` },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.2)" },
  };

  // Nothing loaded (first load failed): centred error with Retry instead of a page of zeros.
  if (!loading && error && !data)
    return (
      <ThemeProvider theme={recruiterTheme}>
        <Box sx={rootSx}>
          <SectionCard>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={1.5} py={6}>
              <Typography sx={{ fontFamily:FONT_BODY, color:"#ef4444", fontSize:TYPE.body }}>{error}</Typography>
              <Button variant="outlined" onClick={()=>load()}
                sx={{ height:CONTROL_HEIGHT.md, fontFamily:FONT_BODY, fontWeight:600, textTransform:"none", borderRadius:`${RADIUS.sm}px` }}>
                Retry
              </Button>
            </Box>
          </SectionCard>
        </Box>
      </ThemeProvider>
    );

  // Full-page spinner only on the first load; later reloads keep the page and show a bar.
  if (loading && !data)
    return (
      <ThemeProvider theme={recruiterTheme}>
        <Box sx={rootSx}>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" flexDirection="column" gap={2} py={5}>
            <CircularProgress size={36} sx={{ color:"#6366f1" }} />
            <Typography sx={{ fontFamily:FONT_BODY, color:"#94a3b8", fontSize:TYPE.body }}>Loading team analytics…</Typography>
          </Box>
        </Box>
      </ThemeProvider>
    );

  return (
    <ThemeProvider theme={recruiterTheme}>
    <Box display="flex" flexDirection="column" gap={3} pb={standalone ? `${PAGE_PADDING}px` : 4} sx={rootSx}>
      {loading && <LinearProgress sx={{ borderRadius:`${RADIUS.sm}px`, bgcolor:"#e0e7ff", "& .MuiLinearProgress-bar":{ bgcolor:"#6366f1" } }} />}
      {error && <Alert severity="error" onClose={()=>setError("")} sx={{ borderRadius:`${RADIUS.md}px` }}
        action={<Button size="small" color="inherit" onClick={()=>load()} sx={{ textTransform:"none", fontWeight:600 }}>Retry</Button>}>{error}</Alert>}

      {/* ── HERO ── */}
      <Card elevation={0} sx={{
        borderRadius:`${RADIUS.lg}px`, overflow:"hidden", position:"relative",
        background:"linear-gradient(135deg, #0f172a 0%, #1e1b4b 45%, #312e81 75%, #4f46e5 100%)",
      }}>
        <Box sx={{ position:"absolute", top:-60, right:-60, width:260, height:260, borderRadius:"50%", background:"rgba(99,102,241,0.12)" }} />
        <Box sx={{ position:"absolute", bottom:-40, right:120, width:160, height:160, borderRadius:"50%", background:"rgba(99,102,241,0.08)" }} />
        <CardContent sx={{ p:3, "&:last-child":{ pb:3 }, position:"relative" }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={3}>
            <Box minWidth={0}>
              <Typography sx={{ fontFamily:FONT_BODY, color:"rgba(165,180,252,0.8)", fontSize:TYPE.overline, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", mb:0.5 }}>
                ResourcingBot · Manager Console
              </Typography>
              <Typography component="h2" sx={{ fontFamily:FONT_DISPLAY, color:"#fff", fontWeight:700, fontSize:{ xs:TYPE.section, md:TYPE.page }, lineHeight:1.25, letterSpacing:"-0.02em", mb:2 }}>
                Recruiter Analytics Dashboard
              </Typography>
              <Box display="flex" gap={1} flexWrap="wrap">
                {[
                  { icon:<Groups sx={{ fontSize:14 }}/>,      label:`${recruiterBreakdown.length} Recruiters` },
                  { icon:<People sx={{ fontSize:14 }}/>,      label:`${kpis.total??0} Candidates` },
                  { icon:<CheckCircle sx={{ fontSize:14 }}/>, label:`${kpis.selected??0} Selected` },
                  { icon:<Cancel sx={{ fontSize:14 }}/>,      label:`${kpis.rejected??0} Rejected` },
                  { icon:<Timeline sx={{ fontSize:14 }}/>,    label:`${kpis.ranged_total??0} in ${periodLabel}` },
                ].map(({icon,label})=>(
                  <Chip key={label}
                    icon={React.cloneElement(icon,{ style:{ color:"rgba(165,180,252,0.9)" } })}
                    label={label} size="small"
                    sx={heroChipSx} />
                ))}
              </Box>
            </Box>
            <Box display="flex" flexDirection="column" gap={1.5} alignItems="flex-end">
              <Box display="flex" gap={1} flexWrap="wrap" justifyContent="flex-end" alignItems="center">
                {PERIODS.map(p=>(
                  <Button key={p.key} size="small" onClick={()=>handlePeriod(p.key)}
                    sx={{ height:CONTROL_HEIGHT.sm, fontFamily:FONT_BODY, fontSize:TYPE.caption, fontWeight:600, textTransform:"none", px:1.5, borderRadius:`${RADIUS.sm}px`, minWidth:0, whiteSpace:"nowrap",
                      color:period===p.key?"#0f172a":"rgba(255,255,255,0.7)",
                      bgcolor:period===p.key?"#fff":"rgba(255,255,255,0.08)",
                      border:"1px solid", borderColor:period===p.key?"#fff":"rgba(255,255,255,0.15)",
                      "&:hover":{ bgcolor:period===p.key?"#f1f5f9":"rgba(255,255,255,0.15)" } }}>{p.label}</Button>
                ))}
                <Tooltip title="Refresh data">
                  <span>
                  <IconButton size="small" onClick={()=>load()} disabled={loading}
                    sx={{ width:CONTROL_HEIGHT.sm, height:CONTROL_HEIGHT.sm, color:"rgba(255,255,255,0.7)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:`${RADIUS.sm}px`, "&:hover":{ bgcolor:"rgba(255,255,255,0.1)" }, "&.Mui-disabled":{ color:"rgba(255,255,255,0.35)" } }}>
                    <Refresh fontSize="small" />
                  </IconButton>
                  </span>
                </Tooltip>
              </Box>
              {showCustom && (
                <Box display="flex" gap={1} alignItems="center" flexWrap="wrap" justifyContent="flex-end">
                  <TextField size="small" type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)} sx={heroDateSx} />
                  <Typography sx={{ fontFamily:FONT_BODY, color:"rgba(255,255,255,0.4)", fontSize:TYPE.caption }}>to</Typography>
                  <TextField size="small" type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)} sx={heroDateSx} />
                  <Button size="small" onClick={()=>load("custom",dateFrom,dateTo)} disabled={loading || customRangeInvalid}
                    sx={{ "&.Mui-disabled":{ bgcolor:"rgba(99,102,241,0.35)", color:"rgba(255,255,255,0.6)" }, height:CONTROL_HEIGHT.md, px:2, bgcolor:"#6366f1", color:"#fff", fontFamily:FONT_BODY, fontWeight:600, fontSize:TYPE.small, textTransform:"none", borderRadius:`${RADIUS.sm}px`,"&:hover":{ bgcolor:"#4f46e5" } }}>
                    Apply
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* ── KPI STRIP ── */}
      <Box sx={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))", gap:2, alignItems:"stretch" }}>
        {[
          { title:"Total Candidates",  value:kpis.total,               icon:<People />,      accent:"#6366f1" },
          { title:`In ${periodLabel}`, value:kpis.ranged_total,        icon:<Timeline />,    accent:"#0ea5e9", sub:"New in selected period" },
          { title:"Selected",          value:kpis.selected,            icon:<CheckCircle />, accent:"#10b981", sub:fmtPct(kpis.selected,kpis.total)+" sel rate" },
          { title:"Rejected",          value:kpis.rejected,            icon:<Cancel />,      accent:"#ef4444", sub:fmtPct(kpis.rejected,kpis.total)+" rej rate" },
          { title:"Recruiters",        value:recruiterBreakdown.length, icon:<Groups />,      accent:"#f59e0b" },
        ].map(c=>(
          <KpiCard key={c.title} {...c} />
        ))}
      </Box>

      {/* ── TOP PERFORMERS ── */}
      <TopPerformersStrip recruiterBreakdown={recruiterBreakdown} />

      {/* ── CHARTS ROW: Funnel + Outcome Bar ── */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <PipelineFunnelChart teamStatusCounts={teamStatusCounts} totalCandidates={kpis.total??0} />
        </Grid>
        <Grid item xs={12} md={7}>
          {/* <RecruiterComparisonChart recruiterBreakdown={recruiterBreakdown} /> */}
           {/* <RecruiterSummaryTable recruiterBreakdown={recruiterBreakdown} /> */}
           <RecruiterRadarChart recruiterBreakdown={recruiterBreakdown} />
        </Grid>
      </Grid>

      {/* ── RECRUITER TABLE ── */}
      {/* <RecruiterSummaryTable recruiterBreakdown={recruiterBreakdown} /> */}

      {/* ── RADAR ── */}
      {/* {recruiterBreakdown.filter(isRealRecruiter).length >= 2 && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <RecruiterRadarChart recruiterBreakdown={recruiterBreakdown} />
          </Grid>
        </Grid>
      )} */}

      {/* ── TIMELINE ── */}
      {/* <RecruiterTimelineChart recruiterBreakdown={recruiterBreakdown} timelineLabels={timelineLabels} periodLabel={periodLabel} /> */}

      {/* ── JD OVERALL ── */}
      <JdOverallSection jdOverall={jdOverall} recruiterBreakdown={recruiterBreakdown} periodLabel={periodLabel} />

      {/* ── PER-RECRUITER DEEP DIVE ── */}
      <Box>
        <Box mb={2}>
          <Box display="flex" alignItems="center" gap={1.5} mb={0.5}>
            <Box sx={{ width:4, height:24, borderRadius:2, bgcolor:"#6366f1" }} />
            <Typography sx={{ fontFamily:FONT_BODY, fontWeight:700, fontSize:TYPE.section, color:"#0f172a", lineHeight:1.3 }}>Per-Recruiter Deep Dive</Typography>
          </Box>
          <Typography sx={{ fontFamily:FONT_BODY, fontSize:TYPE.small, color:"#94a3b8", ml:2 }}>
            Expand each recruiter — pipeline status · active JDs · empty JDs · daily intake chart
          </Typography>
        </Box>
        {recruiterBreakdown.length===0
          ? <SectionCard><Box display="flex" justifyContent="center" alignItems="center" py={5}><Typography sx={{ fontFamily:FONT_BODY, color:"#94a3b8", fontSize:TYPE.body }}>No recruiter data found</Typography></Box></SectionCard>
          : recruiterBreakdown.map((r,i)=>(
              <RecruiterCard key={r.recruiter_id} recruiter={r} color={PALETTE[i%PALETTE.length]}
                timelineLabels={timelineLabels} periodLabel={periodLabel} allRecruiterBreakdown={recruiterBreakdown} />
            ))
        }
      </Box>
    </Box>
    </ThemeProvider>
  );
}
